<template>
  <div>
    <v-img class="background" :src="require('../assets/dark parchment background.jpg')">
    <v-row>
      <v-col cols="12" md="6" sm="12">
        <v-card style="font-weight:500; background:transparent">          
          <v-card-title :style="`color:white; height:68px; background-image:url('${require('../assets/title bar.png')}'); background-size:100% 100%;`"> 
            <v-row justify="end">                    
              <v-col sm="6" style="text-align:center; margin-top:4px">
                <span :style="`font-family:wooden;font-weight:10px; font-size:52px; background-image:url('${require('../assets/wood_boards.jpg')}');background-clip:text;color:transparent;-webkit-background-clip:text;background-position:top;`">Character Stats</span>
              </v-col>
              <v-col sm="3" style="text-align:end; display:flex; justify-content:end; margin-top:4px">
                <v-btn small @click="statsSettingsDoc = true" style="background-color:antiquewhite">Stats Settings</v-btn>
            </v-col>
            </v-row>
          </v-card-title>
        <v-img class="not-background" style="height:342px; margin-top:-4px" :src="require('../assets/skill_bar.png')">
          <v-row dense class="mt-1 mb-0" style="color:white; max-height:340px">
            <v-col cols="3" sm="3" height="15px" class="pl-4">
              <h2>Ability Scores:</h2>
              <div style="height:215px; overflow-y:auto" class="light">
              <div
                v-for="stat in abilityScores"
                v-bind:key="stat"                
              >
                {{ capitalize(stat) }} : {{ stats.characterStats.modifiedStats[stat] }} (+{{tempModifier(stat)}})
              </div>
              </div>
              <br/><br/><br/>
              <span style="position:absolute; bottom:30px; left:20px">xp: {{stats.xp}}/{{stats.nextLevel}}</span>
            </v-col>
            <v-col cols="3" sm="3" height="15px">
              <h2>Stats:<v-icon @click="statsAlt = !statsAlt" style="color:antiquewhite; margin-left:60px">sync</v-icon></h2>
              <div style="height:291px; overflow-y:auto;" class="light firefoxScroll">
              <div
                v-for="stat in miscStats"
                v-bind:key="stat"
              >
                <div v-if="stat == 'spellpoints'">
                  {{capitalize(stat)}}: {{spellpoints}}
                  <div v-if="essenceCount() > 0">
                    <v-tooltip top max-width="500" style="min-height:initial" v-model="showInvestments">
                      <template v-slot:activator="{ }">
                        <span style="margin-right:32px;width:100%" @mouseenter="hoveringEssence = true" @mouseleave="hoveringEssence = false"><span>Essence:  </span><span v-if="!hoveringEssence && !showInvestments"> {{essenceCount()-stats.characterStats.investedEssence}}/{{essenceCount()}}</span><span v-else-if="!showInvestments"><v-btn x-small style="margin-bottom:3px" @click="showInvestments = true">show</v-btn></span> <span v-else><v-btn style="margin-bottom:3px" x-small @click="showInvestments = false">hide</v-btn></span></span> 
                      </template>
                    <div style="pointer-events:all" @mouseleave="showInvestments = false">
                      <v-row no-gutters style="justify-content: center;margin-bottom:2px"><h3>{{stats.characterStats.investedEssence}}/{{essenceCount()}} Invested In: </h3></v-row>
                      <v-divider style="margin-top:0px;margin-bottom:8px; min-width:100%;left:0px; position:absolute"></v-divider>
                      <v-row no-gutters style="margin-bottom:8px"></v-row>
                      <v-row style="align-items: center;" no-gutters v-for="item in getInvestments()" v-bind:key="item.id">
                        <v-col no-gutters cols="8" style="white-space:nowrap; padding-right:16px">
                          <span v-if="item.name == 'Feats:' || item.name == 'Maneuvers:'" style="margin-top:8px">{{item.name}} </span>
                          <div v-else style="margin-top:4px; margin-bottom:4px;margin-left:12px">{{item.investedEssence}}x: {{item.name}} </div>
                        </v-col>
                        <v-col cols="4" no-gutters style="text-align:right">
                          <v-btn v-if="item.name != 'Feats:' && item.name != 'Maneuvers:'" x-small @click="returnInvestments(item)">return</v-btn>
                        </v-col>
                        <v-col cols="12"><v-divider></v-divider></v-col>
                      </v-row>
                      <v-row no-gutters style="justify-content: center; margin-top:8px;margin-bottom:4px"><v-btn x-small @click="returnInvestments('all')">return all</v-btn></v-row>
                    </div>
                  </v-tooltip>
                  </div>
                </div>

                <div v-else-if="stat == 'hp'">
                  <v-tooltip top max-width="500">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{capitalize(stat)}}: {{hp}}</span>
                    </template>
                    <span style="white-space: pre-wrap; max-width:400px">Hp Rolls: <span v-for="(roll,index) in stats.characterStats.hpIncreases" v-bind:key="index"> {{roll}}, </span></span>
                  </v-tooltip>
                  
                </div>
                <div v-else-if="stat == 'fortitude'">
                  {{capitalize(stat)}}: {{parseInt(stats.characterStats.misc[stat]) + parseInt(tempModifier("constitution")) + parseInt(stats.characterStats.tempModifiers[stat]) + parseInt(stats.characterStats.tempModifiers.saves) - Math.abs(parseInt(stats.characterStats.tempModifiers.negativeLevels))}}
                </div>
                <div v-else-if="stat == 'will'">
                  {{capitalize(stat)}}: {{parseInt(stats.characterStats.misc[stat]) + parseInt(tempModifier("wisdom")) + parseInt(stats.characterStats.tempModifiers[stat]) + parseInt(stats.characterStats.tempModifiers.saves) - Math.abs(parseInt(stats.characterStats.tempModifiers.negativeLevels))}}
                </div>
                <div v-else-if="stat == 'reflex'">
                  {{capitalize(stat)}}: {{parseInt(stats.characterStats.misc[stat]) + parseInt(tempModifier("dexterity")) + parseInt(stats.characterStats.tempModifiers[stat]) + parseInt(stats.characterStats.tempModifiers.saves) - Math.abs(parseInt(stats.characterStats.tempModifiers.negativeLevels))}}
                </div>
                <div v-else-if="stat == 'spPerLevel'">
                  Sp Per Level: {{stats.characterStats.misc.spPerLevel + spFromMental}}
                </div>
                <div v-else>
                  {{ capitalize(stat) }} : {{ stats.characterStats.misc[stat]}} 
                </div>


              </div>
              <div v-if="!statsAlt">
              CMB: {{Math.floor(cmb)}}
              CMD: {{Math.floor(cmd)}}
              </div>
              </div>
            </v-col>
            <v-col

              style="height: 330px;"
              class="light firefoxScroll"
            >
              <h2>Skills:</h2>
              <div class="light firefoxScroll"
                style="overflow-y: auto; max-height: 291px;">
              <div
                v-for="stat in characterSkills"
                v-bind:key="stat"                
              >
                {{ capitalize(stat) }} : {{parseInt(stats.characterStats.skills[stat]) + skillModifier(stat) + parseInt(stats.characterStats.tempModifiers[stat]) - parseInt(stats.characterStats.tempModifiers.negativeLevels)}} 
              </div>
              </div>
            </v-col>

            <v-col cols="3" sm="3" height="15px" style="max-height: 336px">
              <h2>Items:</h2>
              <div>                
                Gold: {{stats.gold}}
                <v-row style="margin-left:0px; margin-top:8px; align-items:baseline">
                  <v-text-field dark class="ml-1 mr-2" style="max-width:75px" v-model="goldAmount" label="Use Gold"></v-text-field>
                  <v-btn small style="background-color:antiquewhite" @click="sendGold">Send</v-btn>
                </v-row>
                <!-- <v-row style="justify-content:left" class="ml-0"> -->
                  <v-btn style="background-color:antiquewhite" class="ma-1" @click="potionDialog = true">Backpack</v-btn> 
                  <v-btn style="background-color:antiquewhite" class="ma-1" v-if="store.open" @click="store.visible = true">See Store</v-btn> 
                  <v-btn style="background-color:antiquewhite" class="ma-1" v-if="remainingRolls.length > 0 || (tempPlayerRolls && tempPlayerRolls.length > 0)" @click="showNewRoll = true">See New Roll</v-btn>
                  <v-btn style="background-color:antiquewhite" class="ma-1" v-if="customDialogArray.length > 0" @click="customDialog.visible = true">See Special Option</v-btn>
                  <v-btn style="background-color:antiquewhite" class="ma-1" v-if="wonderousItems.length > 0" @click="showWonderousItemDialog = true">See New Item</v-btn>
                <!-- </v-row> -->
              </div>
            </v-col>  

          </v-row>

          </v-img>
        

          <v-overlay :absolute="true" v-model="recentLevelUp">
            <v-card>
              <v-card-title>Level Up!</v-card-title>
              <v-card-text>        
              You rolled a {{recentHpIncrease}} for Hit points, and went up by {{recentHpIncrease + modifier("constitution")}}<br/>
              Spell points went up by {{recentSpIncrease}}<br/>
              </v-card-text>
              <v-btn color="blue" text @click="recentLevelUp = false"> Hell Yea! </v-btn>                  
            </v-card>
          </v-overlay>
        </v-card>
      </v-col>

      

      <v-col cols="12" md="6" sm="12" v-for="list in listNames" v-bind:key="list">
        <v-card class="mx-auto" elevation="1" :style="`background-color:transparent; height:${list=='spells'? '460' : '400'}px; border-radius:0px`">
          <!-- <v-img :src="require('../assets/big_bar_frame.png')" style="position:absolute; height:68px; width:100%; z-index:2; pointer-events: none;" class="not-background">
            </v-img>   -->
          <v-card-title :style="`width:100%; height:68px; color:white; background-image:url('${require('../assets/title bar.png')}'); background-size:100% 100%; top:-8px`">
            <div style="position:absolute">
              <span v-if="['maneuver','spells','feats','perks'].includes(list) && listHasHidden(list)" style="display:flex">
                <v-icon style="color:antiquewhite" @click="showHiddenDialog(list)">visibility</v-icon>
              </span>
            </div>
            <v-row justify="end" style="width:100%; padding-top:4px">              
              <v-col sm="6" style="text-align:center; font-size:30px; padding-top:10px">
                <span :style="`font-family:wooden;font-weight:10px; font-size:52px; background-image:url('${require('../assets/wood_boards.jpg')}');background-clip:text;color:transparent;-webkit-background-clip:text;background-position:top;`">{{ capitalize(list) }}</span>
                <!-- background-image:url('${require('../assets/wood boards dark.jpg')}');background-clip:text;color:transparent;-webkit-background-clip:text;background-position:top; -->
              </v-col>
              <v-col sm="3" style="text-align:end; display:flex; justify-content:end; margin-top:-1px;padding-top:0px">
                <span style="display:flex; flex-direction:column;width:160px;margin-right:-7px">
                <v-btn small style="background-color:antiquewhite;height:26px;margin-bottom:2px" v-if="list=='maneuver'" @click="disciplineHelpDoc = true">Discipline Rules</v-btn>
                <v-btn small style="background-color:antiquewhite;height:26px" v-if="list=='maneuver'" @click="maneuverDoc = true">Maneuver Mastery</v-btn>
                </span>
                <span style="margin-top:9px">
                <v-btn small style="background-color:antiquewhite" v-if="list=='weapon'" @click="weaponHelpDoc = true">Modifier Settings</v-btn>
                <v-btn small style="background-color:antiquewhite" v-if="list=='armor'" @click="armorHelpDoc = true">Modifier Settings</v-btn>
                </span>
                <span v-if="list=='spells'" style="align-content: center;">

                <v-btn small style="background-color:antiquewhite; width:135px; height:26px; margin-top:-12px" @click="spellMasteryDoc = true">Spell Mastery</v-btn>

                <v-menu nudge-bottom="30" :close-on-content-click="false" transition="slide-y-transition" class="hiddenMenu">
                  <template v-slot:activator="{ props, on }">
                    <v-btn small style="background-color:antiquewhite;width:135px;height:26px; margin-top:-18px" v-bind="props" v-on="on">Spell Recovery</v-btn>                  
                  </template>
                  <span style="height:100%;overflow:hidden">
                  <v-img :src="require('../assets/vertical_mid_frame.png')" :style="`position:absolute; z-index:2; pointer-events: none;`"></v-img>
                  <v-img :src="require('../assets/vertical_mid_frame.png')" :style="`position:absolute; z-index:2; pointer-events: none;bottom:0px`"></v-img>
                  <v-card :style="`background-image:url('${require('../assets/big_bar_bg.png')};background-position:center;`">
                  <div style="background-color:transparent;width:100%; padding-top:12px;margin-bottom:0px;min-height:16px;color:wheat!important; justify-content: space-around;display:flex; margin-right:0px;margin-left:0px">                        
                    <span>E: {{stats.lists.spells.filter(spell=>spell.expended).length}}</span> <span>||</span> <span>R: {{stats.lists.spells.length - stats.lists.spells.filter(spell=>spell.expended).length}}</span>
                  </div>
                    <v-list dense style="background-color:transparent;margin-top:0px;padding-top:0px">                      
                      <v-list-item style="background-color:transparent;width:100%">                        
                        <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="recoverAll('spells')">Recover All</v-btn>
                      </v-list-item >
                      <v-list-item style="background-color:transparent;width:100%">
                        <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="recoverRandom('spells')">Recover Random</v-btn>
                      </v-list-item>
                      <v-list-item style="background-color:transparent;width:100%">
                        <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="expendAll('spells')">Expend All</v-btn>
                      </v-list-item>
                      <v-list-item style="background-color:transparent;width:100%">
                        <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="expendRandom('spells')">Expend Random</v-btn>
                      </v-list-item>
                      </v-list>
                  </v-card>
                  </span>
                </v-menu>


                </span>
              </v-col>
            </v-row>
                      
          </v-card-title>
          <!-- <v-img class="not-background" :style="`${list == hoveringItem ? 'height:unset' : 'max-height:342px'}; margin-top:-0.5px;`" :src="require('../assets/skill_bar.png')"> -->
          <v-row class="pa-0 ma-0 not-background" :style="`height:${list=='spells'? '402' : '342'}px;margin-top:5px!important;`">
            <v-col cols="12" sm="3" class="pa-0 ma-0">
              <v-card elevation="0" :style="`height:${list=='spells'? '402' : '342'}px; background-color:rgb(0,0,0,0)`">
                <div :style="`background-image:url('${require('../assets/big_bar_bg.png')};background-position:center; background-size:100% ${list=='spells' || list=='maneuver' ? '105%': '100%'}; margin-top:${list=='spells' || list=='maneuver' ? '-4px': '0px'};`">
                <v-img :src="require('../assets/big_bar_frame.png')" :style="`position:absolute; height:${['spells','maneuver'].includes(list)? '398' : '338'}px; top:-1px; z-index:2; pointer-events: none;`"></v-img>
                <!-- ${list=='spells' || list=='maneuver' ? '-5px': '-1px'} -->
                <v-chip-group v-if="list=='spells' || list=='maneuver'"
                  mandatory
                  show-arrows
                  density="compact"
                  class="ml-2"
                  dark
                  no-gutters
                  style="max-height: 48px; min-height:46px; padding-bottom:0px;padding-top:4px"
                >
                <v-chip v-if="hasItemsOf(stats.lists[list], 'favorite')" class="px-4 black--text" style="margin-top:0px; padding-left:2px;padding-right:0px; margin-left:2px; margin-right:0px; height:35px; width:35px; justify-content:space-around" @click="focusLevel(list, 'favorite')">
                     <v-icon style="font-size:45px; align-self: center; padding-right: 10px; padding-top:1px" color="yellow">mdi-star-circle</v-icon>
                  </v-chip>

                  <v-chip v-if="hasItemsOf(stats.lists[list], 'expended')" class="pa-4 black--text" style="margin-top:0px;padding-left:2px;padding-right:0px; margin-left:2px; margin-right:0px; height:35px; width:35px; justify-content:space-around" @click="focusLevel(list, 'expended')">
                    <v-icon style="font-size:45px; align-self: center; padding-right: 12px; padding-top:1px" color="red">mdi-alpha-e-circle</v-icon>
                  </v-chip>

                  <v-chip v-for="level in list == 'maneuver'? maneuverLevels: spellLevels" :key="level"
                  :color="focused[list] == level ? 'grey lighten-3' : 'grey darken-3'" class="pa-4 black--text" style="margin-top:0px;padding-left:2px;padding-right:0px; margin-left:2px; margin-right:0px; height:35px; width:35px; justify-content:space-around" @click="focusLevel(list, level)">
                    <v-card>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                        style="line-height:normal; font-size:22px"
                      >
                     {{ level }}
                      </v-row>
                    </v-card>
                  </v-chip>

                  <v-chip v-if="hasItemsOf(stats.lists[list], 'Finisher')" class="pa-4 black--text" style="margin-top:0px;padding-left:2px;padding-right:0px; margin-left:2px; margin-right:0px; height:35px; width:35px; justify-content:space-around" @click="focusLevel(list, 'Finisher')">
                    <v-icon style="font-size:45px; align-self: center; padding-right: 9px; padding-top:1px" color="blue">mdi-alpha-f-circle</v-icon>
                  </v-chip>
                </v-chip-group>
                
                
                <v-list class="light firefoxScroll" :style="`margin-top:-4px;overflow-y: auto; overflow-x:hidden; font-weight:800; background-color:rgb(0,0,0,0);height: ${['spells','maneuver'].includes(list) ? '352px' : list=='maneuver' ? '292px;padding-top:4px;': '338px;padding-top:4px;'}`">
                <draggable :list="stats.lists[list]" :group="{ name: 'all', put:false, pull:false}">
                <div v-for="item in stats.lists[list]" v-bind:key="item.id" :style="`width:100%;`">
                  <div v-if="!item.hidden">
                  <div v-if="!(list == 'spells' || list == 'maneuver') || ((list == 'spells' || list == 'maneuver') && SorMMeets(item,list))" :style="`width:100%;border-width:2.5px; border-style:ridge; border-color:${borderColor(item)}; margin-bottom:2px;`" >
                    <div v-if="(!item.hidden || item.hidden && item.hidden==false)">
                    <v-btn text :style="`font-weight:600; width:100%; padding-left:0px; padding-right:0px; white-space:break-spaces; background-image:linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)),url('${require(`../assets/${backColor(item)}`)}; background-position:center; background-size:100% 100%;margin-bottom:-1px;border-radius:0px`" class="btn-multiline" @click="setFocus(list, item)"> 
                      <!-- <span :style="`color:${getColor(item.rarity)}`">                     ${require('../assets/Background_red.png')}-->
                        <v-icon v-if="item.favorite" :style="`position:absolute; height: 15px;top: -8px; pointer-events: none;width: 10px;font-size: 15px;right: 4px;}`" color="yellow">mdi-star-circle</v-icon>
                        <span :style="`color:${textColor(item)}; font-weight:bold; font-size:16px`">
                      {{ item.name }}
                      </span>
                    </v-btn>
                    <v-divider></v-divider>
                    </div>
                  </div>
                </div>
                </div>
                </draggable>
                </v-list>
                </div>
              </v-card>
            </v-col>
<!-- border-image:url('${require('../assets/Background_red.png')}');border: 10px solid transparent; -->
            <v-col cols="12" sm="9" :style="`${list == hoveringItem ? 'height:unset' : list=='spells' ? 'height:394px;': 'height:334px;'}`" class="pa-0 mr-0">
              <div v-if="list=='maneuver'" style="height:60px;width:100%;margin-top:0px;margin-bottom:0px;position:relative;z-index:1;top:-5px">
                <img :src="require('../assets/combo_bar.png')" style=" height:100%;width:100%;-webkit-user-drag: none;">
                <img :src="require('../assets/basic_bar2.png')" style="width:120px;position:absolute; z-index:1;color:white;top:3px;left:4px">
                <v-row style="position:absolute; z-index:1;top:47px;left:22px;">
                  <v-btn :ripple="false" small style="background-color:antiquewhite;min-width:4px;width:4px;padding-left:9px;padding-right:9px;max-height:18px;font-size:18px;border-radius:2px" @click="stats.characterStats.misc.combo = []">C</v-btn>
                  <v-btn :ripple="false" small style="background-color:antiquewhite;min-width:4px;width:4px;padding-left:9px;padding-right:9px;max-height:18px;font-size:32px;border-radius:2px; margin-left:4px;padding-bottom:2px" @click="stats.characterStats.misc.combo.splice(stats.characterStats.misc.combo.length-1,1)">-</v-btn>
                </v-row>
                <span style="position:absolute; z-index:1;color:white;top:2px;left:20px;color:antiquewhite;font-size:20px;">COMBO:</span>
                <span style="position:absolute; z-index:1;color:white;top:34px;left:54px;color:antiquewhite;font-size:14px;" v-if="stats.characterStats && stats.characterStats.misc && stats.characterStats.misc.combo && stats.characterStats.misc.combo.length > 0">
                  <span v-for="(combo, index) in stats.characterStats.misc.combo" v-bind:key="(combo,index)">
                    <v-tooltip bottom style="margin-right:4px;" open-delay="750">
                    <template v-slot:activator="{ on, attrs }">                      
                      <span v-bind="attrs" v-on="on" @click="stats.characterStats.misc.combo.splice(index,1)"><span :style="`background-color:${comboColor(combo)};font-weight:500;color: ${comboTextColor(combo)}; padding-right:3px;padding-left:3px;border-radius:2px`">{{combo}}</span><span v-if="stats.characterStats.misc.combo[index+1]"> -> </span></span>
                    </template>
                    <span style="width:200px">{{combo}} Mastery: {{maneuverInfo.find(tag=>tag.name == combo).mastery}}
                      <br/><span v-if="focus.maneuver.school=='elementalFlux'"><br/>Elemental Flux Mastery: {{maneuverInfo.find(tag=>tag.name == 'elementalFlux').mastery}}<br/>Combined: {{maneuverInfo.find(tag=>tag.name == 'elementalFlux').mastery + maneuverInfo.find(tag=>tag.name == combo).mastery}}</span>
                      <span v-if="focus.maneuver.school=='solarWind'"><br/>Solar Wind Mastery: {{maneuverInfo.find(tag=>tag.name == 'solarWind').mastery}}<br/>Combined: {{maneuverInfo.find(tag=>tag.name == 'solarWind').mastery + maneuverInfo.find(tag=>tag.name == combo).mastery}}</span>
                      <br/>Click To Remove Combo Point</span>
                  </v-tooltip>
                    <!-- <span :style="`background-color:${comboColor(combo)};font-weight:500;color: ${comboTextColor(combo)}; padding-right:3px;padding-left:3px;border-radius:2px`">{{combo}}</span><span v-if="stats.characterStats.misc.combo[index+1]"> -> </span> -->
                  </span>
                </span>
                
                <span style="position:absolute; color:white; z-index:2;top:5px;left:130px; max-height:60px;" v-if="focus && focus.maneuver.name">
                  <v-row no-gutters>
                      <v-col v-for="tag in getComboTags(focus.maneuver)" v-bind:key="tag">
                        <v-btn outlined block small @click="addCombo(tag)" :style="`background-color:${comboColor(tag)};color:${comboTextColor(tag)}; height:24px;margin-top:1px`">
                          {{tag}} 
                        </v-btn>
                    </v-col>
                  </v-row>
                </span>

                <v-row>
                  <v-divider></v-divider>
                <v-menu nudge-bottom="30" v-if="list=='maneuver'" :close-on-content-click="false" transition="slide-y-transition" class="hiddenMenu">
                  <template v-slot:activator="{ props, on }">
                    <v-btn small style="background-color:antiquewhite;max-width:160px;margin-right:20px;margin-top:-49px;height:28px" v-bind="props" v-on="on">Maneuver Recovery</v-btn>                  
                  </template>
                  <span style="height:100%;overflow:hidden">
                  <v-img :src="require('../assets/vertical_mid_frame.png')" :style="`position:absolute; z-index:2; pointer-events: none;`"></v-img>
                  <v-img :src="require('../assets/vertical_mid_frame.png')" :style="`position:absolute; z-index:2; pointer-events: none;bottom:0px`"></v-img>
                  <v-card :style="`background-image:url('${require('../assets/big_bar_bg.png')};background-position:center;`">
                  <div style="background-color:transparent;width:100%; padding-top:12px;margin-bottom:0px;min-height:16px;color:wheat!important; justify-content: space-around;display:flex; margin-right:0px;margin-left:0px">                        
                    <span>E: {{stats.lists.maneuver.filter(maneuver=>maneuver.expended).length}}</span> <span>||</span> <span>R: {{stats.lists.maneuver.length - stats.lists.maneuver.filter(maneuver=>maneuver.expended && maneuver.type != "Stance" &&  maneuver.type != "Finisher").length}}</span>
                  </div>
                    <v-list dense style="background-color:transparent;margin-top:0px;padding-top:0px">                      
                      <v-list-item style="background-color:transparent;width:100%">                        
                        <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="recoverAll('maneuver')">Recover All</v-btn>
                      </v-list-item >
                      <v-list-item style="background-color:transparent;width:100%">
                        <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="recoverRandom('maneuver')">Recover Random</v-btn>
                      </v-list-item>
                      <v-list-item style="background-color:transparent;width:100%">
                        <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="expendAll('maneuver')">Expend All</v-btn>
                      </v-list-item>
                      <v-list-item style="background-color:transparent;width:100%">
                        <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="expendRandom('maneuver')">Expend Random</v-btn>
                      </v-list-item>
                      </v-list>
                  </v-card>
                  </span>
                </v-menu>
                </v-row>
              </div>
              <!-- <v-img style="height:343px;top:-9px;" :src="require('../assets/skill_bar.png')"> -->
                <v-img v-if="list != hoveringItem" :src="require('../assets/inventory_bar_wide.png')" :style="`position:absolute; ${list=='maneuver'?'top:128px;':'bottom:-6px;'} pointer-events: none; width:75%; ${list == hoveringItem ? 'height:unset' : list=='spells'? 'height:398px;': 'height:338px;'}; ${list == hoveringItem ? 'z-index:4' : 'z-index:2'}`">
                </v-img>
                <v-img v-if="list != hoveringItem" :src="require('../assets/big_bar_bg.png')" :style="`position:absolute; ${list=='maneuver'? 'top:66px;':'bottom:-6px;'} pointer-events: none; right:0px;width:75%; ${list == hoveringItem ? 'height:100%;' : ['spells','maneuver'].includes(list)? 'height:398px;': 'height:338px;'}`">
                </v-img>
              <v-card elevation="0" class="light firefoxScroll mt-2" :style="`top:-9px;overflow-y: auto; height:100%; background-color:rgb(0,0,0,0);`">
                <span @click="maybeOpenNewTab(focus[list])">
                <picker-card
                  :key="pickerIds[list]"
                  class="mr-1 pt-2"
                  :style="`min-height:100%; ${list == hoveringItem ? 'z-index:3' : 'z-index:0'}; border-width:${list == hoveringItem ? '6px' : '0px'}; border-style:ridge; border-color:${borderColor(focus[list])}!important;`"
                  v-if="focus[list] && focus[list] != 'null'"
                  :item="focus[list]"
                  :character="stats.characterStats"
                  :modifierStats="stats.statsForAbilities"
                  @sendCharacter="sendCharacter"
                  @hideItem="hideItem"
                  @toggleReady="toggleReady"
                  @toggleFavorite="toggleFavorite"
                  @reset="reset"
                  @destroy="destroy"
                  @increaseEssence="increaseEssence"
                  @reduceEssence="reduceEssence"
                  @buttonMethod="buttonMethod"
                ></picker-card>
                </span>
              </v-card>
              <v-btn v-if="list != hoveringItem" text class="pa-0" :style="`width:25px !important; min-width:25px!important; height:25px; position:absolute; right:10px;${['spells','maneuver'].includes(list)? 'top:425px;': 'top:365px;'}; z-index:2`" @click="setHover(list)"><v-img style="height:25px; width:25px !important; max-width:25px !important" :src="require('../assets/Mini_arrow_bot2.png')"></v-img></v-btn>
              <v-btn v-else text class="pa-0" :style="`width:25px !important; min-width:25px!important; height:25px; position:absolute;right:10px;${['spells','maneuver'].includes(list)? 'top:425px;': 'top:365px;'}; transform: rotate(180deg);z-index:6`" @click="setHover('none')"><v-img style="height:25px; width:25px !important; max-width:25px !important" :src="require('../assets/Mini_arrow_bot2.png')"></v-img></v-btn>              
              <!-- </v-img> -->
            </v-col>                            
          </v-row>
          <!-- </v-img> -->          
            <!-- <v-img :src="require('../assets/big_bar_bg.png')" >
            
            </v-img> -->
        </v-card>      

      </v-col>
      <v-col md="6" sm="12" v-if="!stickyNotes">
        <v-card height="400" elevation="2" :style="`background:antiquewhite;`">
          <v-card-title style="color:white; max-height:56px" class="headline brown darken-4"> 
            <v-row >
              <v-col style="text-align:center; font-size:30px; margin-top: -4px;" >
                Personal Notes
              </v-col>
              <v-icon class="no-background" @click="enableStickyNotes" style="margin-right:4px; color:antiquewhite">arrow_outward</v-icon>
            </v-row>
          </v-card-title>
          <v-textarea @change="sendCharacter" v-model="stats.notes" dense rows="12" hide-details no-resize style="background-color:antiquewhite; padding-left:4px" class="ma-0 light">
          </v-textarea>
        </v-card>
      </v-col>

      <!-- Draggable sticky notes when enabled -->
      <div v-else 
          :style="`position:fixed; z-index:101; min-width:250px;
                   transform: translate(${notesPosition.x}px, ${notesPosition.y}px); transition: transform ${isDragging ? '0.05s' : '0s'} ease;`"
          class="draggable-notes">
        <v-card elevation="4" :style="`background:antiquewhite;`">
          <v-card-title 
            style="color:white; max-height:56px; cursor:move;" 
            class="headline brown darken-4"
            @mousedown="startDrag"> 
            <v-row id="stickyNotes">
              <v-col style="text-align:center; font-size:30px; margin-top: -4px;" id="stickyNotes">
                Personal Notes
              </v-col>
              <v-icon class="no-background" @click="stickyNotes = false" style="margin-right:4px; color:antiquewhite; background-color:transparent!important">subdirectory_arrow_left</v-icon>
            </v-row>
          </v-card-title>
          <textarea @change="sendCharacter" v-model="stats.notes" style="background-color:antiquewhite; resize:both; width:49vw; height:340px; min-width:270px; min-height:100px; margin-bottom: -6px !important; border:none;outline:none; padding-left:4px" class="ma-0 light">
          </textarea>
        </v-card>
      </div>

        <v-col md="6" sm="12" v-if="stickyNotes">
          <v-card height="400" elevation="0" :style="`background:transparent;`">
            <v-card-title style="color:white; max-height:56px" class="headline brown darken-4"> 
            <v-row>
              <v-col style="text-align:center; font-size:30px; margin-top: -4px;">
                Personal Notes
              </v-col>
              <v-icon class="no-background" @click="stickyNotes = false" style="margin-right:4px; margin-bottom:8px; color:antiquewhite">subdirectory_arrow_left</v-icon>
            </v-row>
          </v-card-title>
          </v-card>
        </v-col>

        <v-col md="6" sm="12">
          <v-card height="400" elevation="2" style="background:antiquewhite">
          <v-card-title style="color:white; max-height:56px" class="headline brown darken-4"> 
            <v-row>                    
              <v-col style="text-align:center; font-size:30px; margin-top: -4px;">
                Group Notes
              </v-col>             
            </v-row>
          </v-card-title>
            <v-textarea @change="sendNotes" v-model="groupNotes" dense rows="12" hide-details no-resize style="background-color:antiquewhite" class="ma-0 light">
            </v-textarea>
          </v-card>
        </v-col>
    </v-row>

      <v-dialog v-model="potionDialog" scrollable height="auto">
          <v-card>
            <v-card-title style="color:antiquewhite; justify-content:center;" class="headline brown darken-4"> Backpack </v-card-title>            
            <v-tabs v-model="tab" background-color="headline brown darken-5" dark align-tabs="center" fixed-tabs>
              <v-tab>
                Potions
              </v-tab>
              <v-tab>
                gear
                </v-tab>
            </v-tabs>
           
            <v-tabs-items v-model="tab" style="height:75vh;">
              <v-tab-item style="height:75vh; overflow-y:hidden">
              <v-img :src="require('../assets/Inventory_bar 2.png')" style="height:100%">
              <v-row no-gutters dense style="height:101%; overflow-y:auto; " class="light2 ml-1">
                <v-col v-for="potionType in Object.keys(potions)" v-bind:key="potionType" lg="3" md="6" sm="12" class="mt-4">
                  <h2 style="color:antiquewhite; text-align:center">{{potionType[0].toUpperCase() + potionType.substr(1)}}</h2>
                  <div v-for="potion in potions[potionType]" v-bind:key="potion.id">
                    <v-card text dense v-if="potion.count > 0" class="mx-1 mb-8 mt-4" dark style="max-height:200px; max-width:440px; background-color:transparent;">
                      <v-img cover :src="require('../assets/inventory_frame.png')" style="max-height:220px;" contain>
                      <v-card-title class="mx-2 pb-1" style="word-break:break-word">
                        {{potion.name}}:<v-spacer/>x{{potion.count}}
                      </v-card-title>
                      <v-card-text class="ml-2 pr-5" style="max-width:98%">{{potion.effect}}</v-card-text>
                      <div style="position:absolute; right:0px;bottom:8px">
                        <v-card-actions class="mr-2 mt-2" style="justify-content:right;">
                          <v-btn text class="ma-2 pa-0" @click="usePotion(potion)">
                          <v-img cover class="ma-0 pa-0" style="max-width:60px; align-items:center" :src="require('../assets/inventory_button.png')">
                              Use
                            </v-img>
                            </v-btn>
                        </v-card-actions>
                      </div>
                      </v-img>
                  </v-card>
                  </div>
                </v-col>
              </v-row>
                </v-img>
              </v-tab-item>

              <v-tab-item >
                <v-tabs v-model="gearTab" align-tabs="center" fixed-tabs background-color="headline grey darken-4" dark>
                  <v-tab v-for="type in gearTypes" :key="type" @click="updateNewGearCounts(type)">
                    {{type}} ({{currentGear(type).length}}) <span v-if="newGearCounts[type] > 0" style="color:red; font-size:9px;margin-bottom:10px">({{newGearCounts[type]}} New)</span>
                  </v-tab>              
                </v-tabs>

                <v-tabs-items v-model="gearTab" class="light2">          
                <v-tab-item v-for="type in gearTypes" :key="type"> 
                  <v-img eager :src="require('../assets/Inventory_bar 2.png')">
                  <v-row style="margin-top:0px; margin-left:0px; max-height:73vh; overflow-y:auto" class="light2 mr-1" >
                  <v-col xl="4" lg="6" sm="12"  v-for="gearItem in currentGear(type)" :key="gearItem.name" style="display:flex; justify-content:center">
                    <v-card text class="ma-3" style="width:600px; height:300px; background-color:transparent">
                      <v-img :src="require('../assets/inventory_frame.png')" style="width:600px; height:300px" width="600" height="300" contain>
                      <v-card-title class="ml-6 mt-4 mr-4" style="color:white">{{gearItem.name}} : <v-spacer/> x{{gearItem.count}}</v-card-title>
                      <v-card-text class="light2 ml-6 mt-2" style="color:white; width:560px; max-height:184px; overflow-y:auto"
                      >Per Stack: {{gearItem.stack}}
                        <br/>Description: <span style="white-space: pre-wrap">{{gearItem.longDesc}}</span>
                        <div v-if="gearItem.featDesc">
                          <br/><br/>Feat Description: {{gearItem.featDesc}}  
                        </div>
                        <div v-if="gearItem.skill">
                          <br/><br/>Skill: {{gearItem.skill}}  
                        </div>
                        <br/>
                      </v-card-text>                    
                      <div class="mr-2 mt-2" style="justify-content:right; position:absolute; right:12px; bottom:20px">
                      <v-btn text class="ma-2 pa-0" @click="useGear(gearItem)">
                            <v-img cover class="ma-0 pa-0" style="max-width:60px; align-items:center; color:white" :src="require('../assets/inventory_button.png')">
                                Use
                              </v-img>
                              </v-btn>
                      </div>
                      </v-img>
                    </v-card>
                  </v-col>
                  </v-row>

                </v-img>
                </v-tab-item>
              </v-tabs-items>
            </v-tab-item>
            </v-tabs-items>
          </v-card>      
      </v-dialog>

    <v-dialog id="newRollDialog" v-model="showNewRoll" v-if="remainingRolls.length > 0 || (tempPlayerRolls && tempPlayerRolls.length > 0)" dark content-class="darkBar">
      <v-card style="overflow: hidden; padding-bottom:16px;" :img="require('../assets/Background_grey.png')">
      <v-card-title style="justify-content:center; font-size:28px" class="grey darken-4">
        <v-tooltip v-if="remainingRolls.length > 1 || (tempPlayerRolls && tempPlayerRolls.length > 0)" right style="margin-right:4px;">
          <template v-slot:activator="{ on, attrs }">
            <v-img @click="goPrevious" :src="require('../assets/Mini_arrow_left2.png')" style="height:40px; max-width:40px" contain v-bind="attrs" v-on="on"></v-img>
          </template>
          <span style="width:200px">Rolls Left: <span v-if="remainingRolls.length > 1">{{remainingRolls.length}}</span><span v-else>{{tempPlayerRolls.length}}</span></span>
        </v-tooltip>

        <v-spacer/>
        <span style="font-size:32px" class="mt-1 mb-1">
        <span v-if="currentRoll && currentRoll.options"> New {{capitalize(currentRoll.options[0].uiType)}} Roll </span>
        <span v-else> New Roll </span>
        <span v-if="currentRoll && currentRoll.options && currentRoll.weapon">&nbsp;For {{currentRoll.weapon.name}}  </span>
        </span>
        <v-spacer/>
        
        <v-tooltip v-if="remainingRolls.length > 1 || (tempPlayerRolls && tempPlayerRolls.length > 0)" right style="margin-right:4px;">
          <template v-slot:activator="{ on, attrs }">
            <v-img :src="require('../assets/Mini_arrow_right2.png')" @click="goNext" style="height:40px; max-width:40px" contain v-bind="attrs" v-on="on"></v-img>
          </template>
          <span style="width:200px">Rolls Left: <span v-if="remainingRolls.length > 1">{{remainingRolls.length}}</span><span v-else>{{tempPlayerRolls.length}}</span></span>
        </v-tooltip>
            
      </v-card-title>
        <v-btn color="blue" text @click="emergencySkip">Skip Roll</v-btn>
        <v-row>
          <v-col
            v-for="option in currentRoll.options"
            v-bind:key="option.id"
            cols="12"
            md="4"
            sm="12" 
          >
          <div @click="select(option)" :class="`${getColorClass(option)} ma-2`">
            <v-tooltip style="margin-right:4px;" bottom open-delay="2000" :disabled="!option.hasSpecialItems">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                 <picker-card     
                    class="mx-2"
                    :item="option"
                    @select="select"
                    :currentWeapons="stats.lists.weapon"
                    :currentArmor="stats.lists.armor"
                    :style="`border-width:thick; border-style:ridge; border-color:${borderColor(option)}!important;`"                          
                  >
                  </picker-card>   
                  </span>             
              </template>
              <span style="width:200px" v-if="option.hasSpecialItems">Alt + Click to open special item's list</span>
            </v-tooltip>

           
          </div>
            <div style="text-align:center; margin-top:6px">
              <v-btn color="white" light @click="select(option)"> Select </v-btn>
            </div>
          </v-col>
        </v-row>        
      </v-card>
    </v-dialog>

    <v-dialog v-model="store.visible" :content-class="`${isMozilla() ? 'firefoxScroll' : 'darkBar2'}`">
      <v-img :src="require('../assets/Inventory_bar 2.png')" class="storeBackground">
        <v-card style="overflow: hidden; background:transparent" >
          <v-toolbar :style="`position:fixed; z-index:1; color:white; max-height:56px; ${isMozilla() ? 'width:-moz-available; margin-right:32px;' : 'width:-webkit-fill-available; margin-right:32px;'}`" class="headline brown darken-4" elevation="0"> Store
            <v-spacer></v-spacer>  
            <h4 class="ml-3">Gold Left: {{stats.gold}}</h4>
            <v-spacer></v-spacer>  
            <div style="display: inline-flex;align-self: baseline;margin-top: 8px;">
              <v-select
                v-model="sendGoldTarget"
                :items="notMe()"
                label="Send Gold To"
                outlined
                dense
                dark
                background-color="brown darken-4"
                style="max-width:200px"
            ></v-select>
            <v-text-field dark class="ml-1 mr-2" style="max-width:75px;margin-top:6px" v-model="goldAmount" label="Amount"></v-text-field>
            <v-btn small style="background-color:antiquewhite;margin-top:6px" @click="sendGoldTo">Send</v-btn>
          </div>
            <v-spacer></v-spacer>  
            <v-btn @click="store.buying=true" :color="store.buying ? 'green' : ''" class="mr-1">Buying</v-btn>
            <v-btn @click="store.buying=false" :color="!store.buying ? 'green' : ''" class="ml-1">Selling</v-btn>          
          </v-toolbar>
          <v-toolbar v-if="store.buying==true" height="42px" :style="`position:fixed; margin-top:56px; z-index:1; color:white; max-height:56px; ${isMozilla() ? 'width:-moz-available; margin-right:32px;' : 'width:-webkit-fill-available; margin-right:32px;'}`" elevation="0">
            <v-tabs fixed-tabs v-model="storeTab" style="background:transparent; height:42px" color="white" background-color="brown">
              <v-tabs-slider color="white">
              </v-tabs-slider>
                <v-tab style="background:transparent; color:antiquewhite" v-for="tab in storeTabs" :key="tab">{{tab}}</v-tab>
            </v-tabs>
          </v-toolbar>
          <v-card style="margin-top:98px; background:transparent">          
            <div v-if="store.buying==true">            
              <v-tabs-items v-model="storeTab" style="width:100%; background:transparent">
                  <v-tab-item item v-for="tab in storeTabs" :key="tab" style="background:transparent">              
                    <div v-for="itemType in store.itemTypes" v-bind:key="itemType.type">
                      <div v-if="itemType.storeType == tab || (!itemType.storeType && tab=='gear')">                               
                        <h2 style="margin-left:15px; color:white; text-align:center">{{itemType.type.toUpperCase()}}</h2>
                        <v-row style="margin:30px; justify-content:center">                
                          <div v-for="item in store.remainingItems" v-bind:key="item.id" cols="12" sm="2">
                            <v-card v-if="item.name == itemType.type || (item.type && item.type == itemType.type)" style="text-align:center; margin:10px; padding:10px;" dark>
                              <v-card-title v-if="!item.specific" style="justify-content:center">{{item.typed ? "Typed" : ""}} {{capitalize(item.name)}}</v-card-title>
                              <div v-if="item.desc">
                                <div :style="`width:400px;margin-bottom:24px`">{{item.desc}}</div>
                              </div>
                              <div v-if="item.specific">
                                <picker-card :style="`width:400px; border-style:ridge; border-width:thick; border-color:${borderColor(item.option)}!important`" :item="item.option"></picker-card>
                              </div>                              
                              <div v-if="item.boughtBy == ''"> Price: {{item.price}} 
                              <v-btn color="blue" :disabled="stats.gold < parseInt(item.price)" @click="buyItem(item)"> Buy </v-btn>
                              </div>   
                              <div v-if="item.boughtBy != ''" style="color:red"> Bought By: {{item.boughtBy}}</div>
                            </v-card>  
                          </div>              
                        </v-row>                       
                      </div>
                    </div> 
        
                  </v-tab-item>
              </v-tabs-items>
            </div>

            <v-row v-else >
              <v-col
                v-for="item in store.sellableItems"
                v-bind:key="item.id"
                cols="12"
                sm="4"
              >
                <v-card dark v-if="item.item" style="text-align:center; max-height:400px; overflow-x:auto">              
                    <picker-card :item="item.item" style="max-height:334px; overflow-y: auto" class="darkBar"></picker-card>
                    <!-- <div>Sold</div> -->
                  <v-card-actions > Price: {{item.price}} 
                  <v-btn color="blue" @click="sellItem(item)"> sell </v-btn>
                  </v-card-actions>                
                </v-card>
              </v-col>
            </v-row>            
          </v-card >  
        </v-card>
      </v-img>
    </v-dialog>      

    <v-dialog v-model="disciplineHelpDoc">
          <v-card style="overflow: hidden; background-color:antiquewhite; height:80vh">
          <v-card-title class="headline brown darken-4 white--text">Discipline Info </v-card-title>
          <v-card-text style="color:black; overflow-y:hidden; height:97%;" class="px-0">
            <discipline-info style="height:100%; overflow-y:auto; padding-bottom:30px" class="light px-2"/>
          </v-card-text>        
      </v-card>
    </v-dialog>

    <v-dialog v-model="maneuverDoc" :content-class="`${isMozilla() ? 'firefoxScroll' : 'darkBar2'} nooverflow`">
          <v-card style="overflow: hidden; background-color:transparent;width:100%;min-height: 70vh;">
          <v-img :style="`background-image:url('${require('../assets/Inventory_bar 2.png')};background-repeat: round;min-height: 70vh;`">
          <v-card-title class="headline brown darken-4" :style="`width: 100%; overflow:hidden; color:antiquewhite;justify-content: center;font-size:42px!important`" hide-details="auto"><v-spacer/><v-spacer/>Maneuver Info<v-spacer/>
            <v-select style="width:300px;max-width:300px;background-color:antiquewhite;" class="noBottom" hide-details="true"
                v-model="comboSortBy" :items="['Alphabetic','Mastery']" dense solo-filled outlined></v-select>
          </v-card-title>          
            <v-row no-gutters style="overflow-x:hidden;justify-content:center;overflow-y:scroll;max-height:80vh; padding-left:16px;padding-bottom:32px" v-if="stats.lists.maneuver.length > 0" class="darkBar2">
              <v-col v-for="tag in maneuverInfo.filter(tag=>tag.count > 0)" v-bind:key="tag.id" class="py-2 mx-4 my-2" sm="2">
                <v-card :style="`background-image:url('${require('../assets/big_bar_bg.png')};background-position:center;color:white; overflow:hidden; height:100%;max-height:475px; width:100%; box-shadow: ${comboColor(tag.name)} 0 0 25px${additionalComboColor(tag.name)};`">
                  <v-img eager :src="require('../assets/vertical_mid_frame.png')" :style="`position:absolute; bottom:0px;width:100%;  pointer-events: none;`" cover></v-img>
                  <v-img eager :src="require('../assets/vertical_mid_frame.png')" :style="`position:absolute; clip-path: inset(0px 0px 75% 0px);width:100%;  pointer-events: none;`" cover></v-img>
                  <v-card-title :style="`padding-top:24px;justify-content:center; color: ${comboColor(tag.name)}; text-shadow: ${comboShadowColor(tag.name)} 0 0 30px;font-size:32px`">{{capitalize(tag.name)}}</v-card-title>                  
                  <v-divider color="antiquewhite"></v-divider>
                  <v-card-subtitle class="py-2" style="color:antiquewhite">
                    <v-row>
                      <v-col style="text-align:center">
                    Total Known: <br/>{{tag.count}} 
                      </v-col>
                      <v-col style="text-align:center">
                        Levels Known: <br/>{{tag.levels.filter(level=> level.count > 0).length}}
                      </v-col>
                    </v-row>
                    <v-row style="justify-content:center; font-size:22px;margin-bottom:6px">
                      Mastery: {{tag.mastery}}
                    </v-row>
                  </v-card-subtitle>
                  <v-divider color="antiquewhite"></v-divider>
                  <v-card-text style="color:antiquewhite">
                    <div style="text-align:center; margin-bottom:12px">
                    Types Known:
                    </div>
                    <v-row style="margin-bottom:24px;text-align:center">
                      <v-col v-for="key in Object.keys(tag.types)" v-bind:key="key" style="white-space:nowrap;padding-bottom:0px;text-align:center">{{key}}s: {{tag.types[key]}}</v-col>
                    </v-row>
                    <v-divider style="margin-top:4px;margin-bottom:8px" color="antiquewhite"></v-divider>
                    <div style="text-align:center; margin-bottom:12px">
                      Levels Known:
                    </div>
                    <v-row no-gutters style="text-align: center;max-width:360px;margin-bottom:6px">
                        <v-col v-for="level in tag.levels.filter(level=>level.count > 0)" :key="level.level" cols="6" class="my-1">
                        level {{level.level}}: <span :style="`padding-right:6px;padding-left:6px;border-width: 0px 0px 2px 0px;;border-style: ridge;border-color: antiquewhite`"> {{level.count}} </span>
                        </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>           
            </v-img>
      </v-card>
    </v-dialog>

    <v-dialog v-model="spellMasteryDoc" :content-class="`${isMozilla() ? 'firefoxScroll' : 'darkBar2'} nooverflow`">
      <v-card style="overflow: hidden; background-color:transparent;width:100%;min-height: 70vh;">
        <v-img :style="`background-image:url('${require('../assets/Inventory_bar 2.png')};background-repeat: round;min-height: 70vh;`">
          <v-card-title class="headline brown darken-4" :style="`width: 100%; overflow:hidden; color:antiquewhite;justify-content: center;font-size:42px!important`" hide-details="auto">Spell Mastery Info
          <!-- <v-icon @click="copySpellRoll('universal')" style="position:absolute; right:16px; top:16px; color:antiquewhite" large>settings</v-icon> -->
           <v-checkbox v-model="includeEquippedWeapons" label="include Equipped Weapon" style="position:absolute; right:16px; top:6px;" dark></v-checkbox>
          </v-card-title>
            <v-row no-gutters style="overflow-x:hidden;justify-content:center;overflow-y:scroll;max-height:80vh; padding-left:16px;padding-bottom:32px" class="darkBar2">
              <v-btn @click="spellRulesDoc = true" dark>Spell Rules</v-btn>
              <v-col v-for="spellType in ['universal','fire','acid','cold','electricity','positive','negative']" v-bind:key="spellType" class="py-2 mx-4 my-2" sm="2">
                <v-card :style="`background-image:url('${require('../assets/big_bar_bg.png')};background-position:center;color:white; overflow:hidden; height:100%;max-height:475px; width:100%; box-shadow: ${spellColor(spellType)} 0 0 25px;`">
                  <v-img eager :src="require('../assets/vertical_mid_frame.png')" :style="`position:absolute; bottom:0px;width:100%;  pointer-events: none;`" cover></v-img>
                  <v-img eager :src="require('../assets/vertical_mid_frame.png')" :style="`position:absolute; clip-path: inset(0px 0px 75% 0px);width:100%;  pointer-events: none;`" cover></v-img>
                  <v-card-title :style="`padding-top:24px;justify-content:center;`"><span :style="`color: ${spellColor(spellType)}; text-shadow: ${spellTitleColor(spellType)} 0 0 30px;font-size:32px`">{{capitalize(spellType)}}</span><v-icon @click="copySpellRoll(spellType)" style="position:absolute; right:16px; top:16px; color:antiquewhite" large>mdi-dice-d20</v-icon></v-card-title>                  
                  <v-divider color="antiquewhite"></v-divider>
                  <!-- <v-card-subtitle class="py-2" style="color:antiquewhite">
                    <v-row>
                      <v-col style="text-align:center">
                        Total Known: <br/>Lol Idk 
                      </v-col>
                      <v-col style="text-align:center">
                        Levels Known: <br/>Lol Idk
                      </v-col>
                    </v-row>
                    <v-row style="justify-content:center; font-size:22px;margin-bottom:6px">
                      Mastery:
                    </v-row>
                  </v-card-subtitle> -->
                  <v-divider color="antiquewhite"></v-divider>
                  <v-card-text style="color:antiquewhite">
                    <div style="text-align:center; margin-bottom:12px">
                      <v-row style="align-items:baseline">
                        <v-col cols="6">
                          Spell Power:  
                        </v-col>
                        <v-col cols="3">
                          <span style="white-space: nowrap;">{{spellMasteryParser(spellType, 'spellPower', 'total') }} <span v-if="spellType != 'universal'">({{ spellMasteryParser(spellType, 'spellPower', 'specific') }})</span></span>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field dark v-model="stats.characterStats.spellMastery.modifier.spellPower[spellType]" dense single-line style="max-width: 50px; margin-left: 4px; text-align-last:center;" @change="trigger('spellPower', spellType)"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row style="align-items:baseline">
                        <v-col cols="6">
                          Spell Critical Chance: <br/>
                        </v-col>
                        <v-col cols="3">
                          <span style="white-space: nowrap;">{{ spellMasteryParser(spellType, 'spellCriticalChance', 'total') }}% <span v-if="spellType != 'universal'">(+{{ spellMasteryParser(spellType, 'spellCriticalChance', 'specific') }}%)</span></span>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field dark v-model="stats.characterStats.spellMastery.modifier.spellCriticalChance[spellType]" dense single-line style="max-width: 50px; margin-left: 4px; text-align-last:center;" @change="trigger('spellCriticalChance', spellType)"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row style="align-items:baseline">
                        <v-col cols="6">
                          Spell Critical Damage: 
                        </v-col>
                        <v-col cols="3">
                          <span style="white-space: nowrap;">+{{ spellMasteryParser(spellType, 'spellCriticalDamage', 'total') }}% <span v-if="spellType != 'universal'">(+{{ spellMasteryParser(spellType, 'spellCriticalDamage', 'specific') }}%)</span></span>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field dark v-model="stats.characterStats.spellMastery.modifier.spellCriticalDamage[spellType]" dense single-line style="max-width: 50px; margin-left: 4px; text-align-last:center;" @change="trigger('spellCriticalDamage', spellType)"></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <!-- <v-row no-gutters style="text-align: center;max-width:360px;margin-bottom:6px">
                        <v-col v-for="level in spellType.levels.filter(level=>level.count > 0)" :key="level.level" cols="6" class="my-1">
                        level {{level.level}}: <span :style="`padding-right:6px;padding-left:6px;border-width: 0px 0px 2px 0px;;border-style: ridge;border-color: antiquewhite`"> {{level.count}} </span>
                        </v-col>
                    </v-row> -->
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>           
          </v-img>
      </v-card>
    </v-dialog>

    <v-dialog v-model="weaponHelpDoc">
      <v-card style="overflow: hidden; background-color:antiquewhite;">
        <v-card-title class="headline brown darken-4 white--text" >Weapon Modifier Settings</v-card-title>
        <v-card-text style="color:black; font-weight:500" class="ma-1 pt-2 pb-1">
          These Approximate numbers were generated assuming you're using strength for attack and damage, and all other default modifiers including: <br /><br />
          <b style="margin-left:40px">Attack:</b><br/> Melee: Strength + BAB + Modifier Weapon Enchantments <br /> Ranged: Dexterity + BAB + Modifier Weapon Enchantments <br /> <br />
          <b style="margin-left:40px">Damage:</b><br/> All damage rolls are modified by the weapons base damage dice + modifier weapon enchantments + elemental weapon enchantments<br /> Additionally depending on the type of weapon: <br /> Light/One Handed: Strength  <br /> Two Handed: Strength * 1.5 <br />Off-hand: Strength / 2 <br/>Ranged: Only throwing weapons and long bows are affected by strength, and longbows are capped at 5 
          <br /><br />
          <div style="display:inline-flex;align-items:baseline">          
            Global Attack Modifier:<v-text-field v-model="stats.statsForAbilities.bonusAtk" class="ml-1" dense single-line style="width: 50px" :rules="[rules.number]"></v-text-field>          
          </div><br />
          <div style="display:inline-flex;align-items:baseline"> 
            Global Damage Modifier:<v-text-field v-model="stats.statsForAbilities.bonusDmg" class="ml-1" dense single-line style="width: 50px" :rules="[rules.number]"></v-text-field>
          </div>
          <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="stats.statsForAbilities.powerAttack" label="Power Attack"></v-checkbox>
          <!-- <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="stats.statsForAbilities.combatExerptise" label="Combat Expertise"></v-checkbox> -->
          <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="stats.statsForAbilities.lvlForBab" label="Use level for BAB"></v-checkbox>
      </v-card-text>
      <v-btn class="ma-3 brown darken-4 white--text" text @click="newWeaponDialog = true">Create New Weapon</v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newWeaponDialog" width="600">
      <v-card style="overflow: hidden; background-color:antiquewhite;max-width:600px">
        <v-card-title class="headline brown darken-4 white--text" >Create New Weapon</v-card-title>
        <v-card-text style="color:black; font-weight:500" class="ma-1 mt-4 pt-2">
          <v-row style="justify-content:center">
            <v-text-field label="Name" v-model="newWeapon.name" dense style="max-width: 300px" :rules="[rules.minLength]"></v-text-field>
          </v-row>
          <v-row style="justify-content:left">
            <v-text-field label="Damage" v-model="newWeapon.damage" dense style="max-width: 200px" :rules="[rules.minLength]"></v-text-field>
            <v-text-field label="Critical" v-model="newWeapon.critical" class="ml-3" dense style="max-width: 200px" :rules="[rules.minLength]"></v-text-field>
            <v-text-field label="Damage Type" v-model="newWeapon.damageType" class="ml-3" dense style="max-width: 200px"></v-text-field>
          </v-row>
          <v-row>
            <v-textarea label="Notes:" v-model="newWeapon.notes" dense outlined style="width: 400px;" no-resize></v-textarea>
          </v-row>
      </v-card-text>
      <v-row style="justify-content:center" class="mb-3">
        <v-btn class="ma-2 brown darken-4 white--text" @click="createNewWeapon()">Create</v-btn>
      </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-model="armorHelpDoc">
      <v-card style="overflow: hidden; background-color:antiquewhite;">
        <v-card-title class="headline brown darken-4 white--text">Armor Modifier Help</v-card-title>
        <v-card-text style="color:black; font-weight:500" class="ma-1 pt-2">
          These Approximate numbers were generated assuming your armors max dex affects you, and that youre using dex to ac <br />
          <b>AC:</b> 10 + dex (up to max dex) + armor + deflection + shield + natural armor + modifier armor enchantments + dodge <br />
          <b>Flat Footed:</b> 10 + armor + shield + deflection + natural armor + modifier armor enchantments <br />
          <b>Touch:</b> 10 + dex (up to max dex) + deflection + dodge
          <br /><br />
          AC Ability Score:
          <v-combobox
            style="width:150px"
            v-model="stats.statsForAbilities.ac.abilityMod"
            :items="statNames"            
            outlined
            dense
          ></v-combobox>
          <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="stats.statsForAbilities.combatExpertise" label="Combat Expertise"></v-checkbox>
          <v-row>
            <v-col class="aligned-col" no-gutters sm="4">
              Max Dex Bonus Modifier:
              <v-text-field v-model="stats.statsForAbilities.ac.armorCheckMod" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Deflection Bonus:
              <v-text-field v-model="stats.statsForAbilities.ac.deflection" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>    
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Armor Bonus:
              <v-text-field v-model="stats.statsForAbilities.ac.armor" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Shield Bonus:
              <v-text-field v-model="stats.statsForAbilities.ac.shield" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Natural Armor Bonus:
              <v-text-field v-model="stats.statsForAbilities.ac.natural" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Dodge Bonus:
              <v-text-field v-model="stats.statsForAbilities.ac.dodge" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Insight Bonus:
              <v-text-field v-model="stats.statsForAbilities.ac.insight" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Luck Bonus:
              <v-text-field v-model="stats.statsForAbilities.ac.luck" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Sacred/Profane Bonus:
            <v-text-field v-model="stats.statsForAbilities.ac.sacred" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Size Bonus:
            <v-text-field v-model="stats.statsForAbilities.ac.size" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>
            <v-col class="aligned-col" no-gutters sm="4">
              Untyped Bonus:
              <v-text-field v-model="stats.statsForAbilities.ac.untyped" dense single-line style="max-width: 50px; margin-left: 4px" :rules="[rules.number]"></v-text-field>
            </v-col>            
          </v-row>
      </v-card-text>        
      </v-card>
    </v-dialog>

    <v-dialog v-model="customDialog.visible" style="overflow:hidden">
      <v-card dark style="overflow:hidden;">
      <v-card-title class="headline brown darken-4" style="justify-content:center">{{customDialog.title}}</v-card-title>
      <v-img v-if="customDialog.title == 'Wait, No Trade Up?'" :src="require('../assets/no refunds.png')" style="height:400px" contain></v-img>
      <v-img v-if="customDialog.title == 'Chat is this guy fr?'" :src="require('../assets/read the store text.png')" style="height:400px" contain></v-img>
      <div v-if="customDialog.title=='Maneuver Trade Up'" style="text-align: center;margin-top: 36px;margin-bottom: 24px;"
      >Select 3 maneuvers to trade for a typed maneuver.<br/> If you select 3 maneuvers of the same school, it will instead be a finisher from that school.</div>
      <v-row v-if="customDialog.title!='Maneuver Trade Up'" style="overflow-y:auto; margin:8px 8px 8px 8px;">
        <v-col v-for="option in customDialog.options" v-bind:key="option.id" cols="3" md="3" sm="4">
          <v-card v-if="option.isItem">
              <picker-card style="overflow-y: auto;" class="darkBar" :item="option.item"></picker-card>
               <v-card-actions style="justify-content:center">
                <v-btn @click="runCustomMethod(option.method, option)">Select</v-btn>
              </v-card-actions>
          </v-card>
          <v-card v-else style="border-style:ridge;border-width:thick">
              <v-card-title style="justify-content:center;white-space: pre;">{{capitalize(option.title)}}</v-card-title>
              <v-card-text v-if="option.description" style="white-space: pre-wrap">{{option.description}}</v-card-text>              
              <v-card-actions style="justify-content:center">
                <v-btn v-if="customDialog.title == 'Wait, No Trade Up?' && option.title == 'I Dont Have Enough Maneuvers...?'" @click="runCustomMethod(option.method, option)">I Understand 😔</v-btn>
                <v-btn v-else-if="customDialog.title == 'Wait, No Trade Up?' && option.title == 'Wait Amelia-sama 👉👈... Pwease Wefund?'" @click="runCustomMethod(option.method, option)">(Push Luck)</v-btn>
                <v-btn v-else-if="customDialog.title == 'Chat is this guy fr?'" @click="runCustomMethod(option.method, option)">(Lie)</v-btn>
                <v-btn v-else @click="runCustomMethod(option.method, option)">Select</v-btn>
              </v-card-actions>
          </v-card>
      </v-col>
      </v-row>
       <v-row v-else style="margin:8px 8px 8px 8px;">
        <v-row v-for="index in 9" v-bind:key="index" style="width:100%">
          <v-col cols="12" sm="12" style="width:100%;height:10px;display: flex;align-items: center; margin-top: 24px;font-size:36px"><v-divider style="margin-right:8px"></v-divider>Level {{index}}<v-divider style="margin-left:8px"></v-divider></v-col>
          <v-col v-for="option in customDialog.options.filter(dbOption=> dbOption.item.level == index && dbOption.item.level != 'enlightenedPath')" v-bind:key="option.id" cols="3">
            <v-card :style="`border-style:ridge;border-width:thick; border-color:${option.item.school ? comboColor(comboTags[option.item.school][0]) : 'white'}`">
              <picker-card v-if="customDialog.title=='Maneuver Trade Up'" style="max-height:200px; overflow-y: auto;" class="darkBar" :item="option.item"></picker-card>              
              <v-card-actions style="justify-content:center"><v-btn @click="runCustomMethod(option.method, option)">Select</v-btn></v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-row>
      
      </v-card>
    </v-dialog>

    <v-dialog v-model="customSpellDialog.visible" style="overflow:hidden" persistent>
      <v-card dark style="overflow:hidden;">
      <v-card-title class="headline brown darken-4" style="justify-content:center">{{customSpellDialog.title}}</v-card-title>
      <span v-if="customSpellDialog.text && customSpellDialog.maxLength">Characters: {{ customSpellDialog.text.length }} Characters Left: {{ customSpellDialog.maxLength - customSpellDialog.text.length  }}</span>
      <v-textarea v-model="customSpellDialog.text" :maxlength="customSpellDialog.maxLength" style="width:100%; height:100%;" no-resize></v-textarea>
      <v-card-actions style="justify-content:center">
        <v-btn @click="createSpell">Accept</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showWonderousItemDialog" style="overflow:hidden;">
      <v-card dark style="overflow:hidden; min-height:200px">
        <v-card-title class="headline brown darken-4" style="justify-content:center">Party Drops
          <v-spacer></v-spacer>
          <v-tooltip right style="margin-right:4px;">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" style="color:saddlebrown">help_outline</v-icon>
              </template>
              <span style="width:200px">Random wonderous items sometimes drop from from loot piles, allowing players a choice on whether to roll for the item or not. <br/>Each Player has 60 seconds to select one of the options:<br/>Need: roll d100<br/>Greed: d100 -15</span>
            </v-tooltip>
          </v-card-title>
        <v-row style="overflow-y:auto; margin:8px 8px 8px 8px; justify-content:space-evenly">
          <v-col cols="4" v-for="item in wonderousItems" :key="item.item.id">
            <v-card style="border-style:ridge;border-width:thick" >
                <picker-card :item="item.item" style="max-height:334px; overflow-y: auto" class="darkBar"></picker-card>
                <v-card-actions style="justify-content:center">
                  <v-col>
                    <v-row style="justify-content:center">
                    <div v-if="item.roll == -1">
                      <v-btn class="ma-1" @click="rollForItem('need',item.item)">Need</v-btn>
                      <v-btn class="ma-1" @click="rollForItem('greed', item.item)">Greed</v-btn>
                      <v-btn class="ma-1" @click="rollForItem('skip', item.item)">Skip</v-btn>
                    </div>
                    <div v-else>
                      Rolled: {{item.roll}}
                    </div>
                    </v-row>
                    <v-row style="justify-content:center">
                    <v-img :src="require('../assets/xp_background.png')" style="height:22px">
                    <span style="position:absolute; z-index: 3; left:49%;">{{item.intervalCount}}</span>
                      <v-img cover :src="require('../assets/xp_line.png')" :style="`width:${Math.floor((item.intervalCount/60)*100)}%; height:100%;`">                        
                      </v-img>
                    </v-img>
                    </v-row>
                  </v-col>
                </v-card-actions>
                <span ></span>
            </v-card>
            </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-model="statsSettingsDoc">
      <stat-settings style="overflow-x:hidden; overflow-y:hidden" :characterSheet="stats.characterStats" :statsForAbilities="stats.statsForAbilities"></stat-settings>
    </v-dialog>

    <v-dialog v-model="spellRulesDoc">
      <v-card style="overflow-x:hidden">
        <v-card-title class="headline brown darken-4 white--text" style="justify-content: center;">Spell Rules</v-card-title>
        <v-card-text style="color:black; background-color:antiquewhite; font-weight:500" class="pt-8">
          <b>Spell Power:</b>
          <p>
          Spells deal bonus damage or heal a bonus percentage based on your spell power of that type, 1 power means 1% bonus damage or healing. The total amout is listed in the elemental section in the format of: {Total Power} ({Specific Element Power}). The {Total amount} is the {Specific Element Amount} + {Universal Amount}. If something says it scales with 200% spell power, that means count your spell power for double what it usually is, and that it can critically hit with your spell critical chance, but the spell critical chance or power is not modified by this.
          <br/><br/>Spells effect spells of their type and subtype, <ul><li>Fire: Fire + Light</li><li>Acid: Acid + Earth</li><li>Cold: Cold + Water</li><li>Electricity: Electricity + Air</li><li>Positive: Positive energy damage and healing + Temporary Hit Points</li><li>Negative: Negative + Death (negative levels, death range, etc.)</li></ul>
          <br/>If a spell deals damage of two types, it deals the average of both types rounded down. This applies to critical chance and damage multiplier as well. You can choose to roll them seperately if you'd like, this is just to save time. 
          </p>
          <b>Spell Critical:</b>
          <p>
          Spells that deal damage have a percentage chance to critically hit. If a spell critically hits, it multiplies the total damage by the critical damage percentage, in the format of: (spell damage dice * (1+(spell power/100)))*(1+(spell critical damage/100)). You can click the d20 at the top right of the spell mastery to copy the formula.
          <br/>You roll the critical chance every time the spell deals damage or heals. The exception is fast healing/regeneration for fast healing.
          </p>
          <br />
          <b>Spell Critical Damage:</b>
          <p>
          Spells that critically hit deal damage equal to the spell's damage multiplied by the critical damage percentage. If a spell is a ray, it has the chance to critically hit normally. If you do, increase the critical damage multiplier by 100% per critical multiplier above x1.
          </p>
          <br/><b>Skill to Spell Bonuses:</b>
          <p
          >Additionally, your skills empower your spells as well. This only includes your base skill ranks. 
          <v-row>
            <v-col v-if="skillToSpellBonus.spellPower">
              <h3>Power:</h3>
              <table>
                    <tr>
                      <th>Type</th>
                      <th>Skill</th>
                      <th>Rate</th>
                    </tr>
                    <tr v-for="(power, type) in skillToSpellBonus.spellPower" :key="type">
                      <td>{{ type[0].toUpperCase() + type.slice(1) }}</td>
                      <td>{{ power.skill }}</td>
                      <td>{{ power.rate }}</td>
                    </tr>
                  </table>
              </v-col>
            <v-col>
              <h3>Critical Chance:</h3>
              <table>
                    <tr>
                      <th>Type</th>
                      <th>Skill</th>
                      <th>Rate</th>
                    </tr>
                    <tr v-for="(chance, type) in skillToSpellBonus.spellCriticalChance" :key="type">
                      <td>{{ type[0].toUpperCase() + type.slice(1) }}</td>
                      <td>{{ chance.skill }}</td>
                      <td>{{ chance.rate }}</td>
                    </tr>
              </table>
            </v-col>
            <v-col>
              <h3>Critical Damage:</h3>
              <table>
                    <tr>
                      <th>Type</th>
                      <th>Skill</th>
                      <th>Rate</th>
                    </tr>
                    <tr v-for="(damage, type) in skillToSpellBonus.spellCriticalDamage" :key="type">
                      <td>{{ type[0].toUpperCase() + type.slice(1) }}</td>
                      <td>{{ damage.skill }}</td>
                      <td>{{ damage.rate }}</td>
                    </tr>
              </table>
            </v-col>
          </v-row>
          </p> 
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="hiddenDialog.show">
      <hidden-dialog :type="hiddenDialog.type" :items="hiddenDialog.items" @hideItem="hideItem"/>
    </v-dialog>
  </v-img>
  </div>
</template>
<script>
import Draggable from 'vuedraggable';
import StatSettings from "./StatSettings"
import PickerCard from "./PickerCard"
import {potions as potionList, skills, perks, roguePerks, feats, fighterPerks, levelUpPerks, races, kiPerks, classRoll,recoveryPerks} from "./data"
import DisciplineInfo from './disciplineInfo';
import {gearTypes, comboTags, comboTagText, skillToSpellBonus} from './constants'
import hiddenDialog from './hiddenDialog'
import goldDrop from '../assets/goldDrop.mp3'
import itemDrop from '../assets/itemDrop.wav'
import rareItem from '../assets/rareItem.wav'
import vineBoom from '../assets/vine boom.mp3'
export default {
  components: {
    PickerCard,
    StatSettings,
    DisciplineInfo,
    hiddenDialog,
    Draggable
  },
  props: {
    newRoll: {},
    connection: {},
    setCharacter:{},
    communalUpdate:{},
    tempPlayerRolls:[],
    tempCustomDialogs:[],
    username:String,
    password:String,
    name:String,
    isGM:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      newGearCounts:{ammunition:0, grenade:0, blanch:0, utility:0, implement:0},
      spellRulesDoc:false,
      skillToSpellBonus:skillToSpellBonus,
      includeEquippedWeapons:true,
      stickyNotes:false,
      comboSortBy:"Alphabetic",
      comboTagText:comboTagText,
      comboTags:comboTags,
      updateInterval:{},
      pickerIds:{
        maneuver:Math.random(),
        feats:Math.random(),
        spells:Math.random(),
        wonderousItems:Math.random(),
        weapon:Math.random(),
        armor:Math.random(),
        parks:Math.random(),
      },
      showInvestments:false,
      hoveringEssence:false,
      keyListener:{},
      shiftDown: false,
      ctrlDown: false,
      altDown: false,
      url:
        window.location.href == "http://localhost:8080/"
          ? "http://localhost:7071/api/HttpTrigger1"
          : "/api/HttpTrigger1",
      firstSend:true,
      sendGoldTarget:"",
      statsAlt:false,
      accountPerks:{},
      customDialog:{},
      customDialogArray:[],
      customSpellDialog:{},
      customSpellArray:[],
      levelUpMethods:[],
      recentFocus:{},
      rules: {
          number: value => {            
            return (parseInt(value) || value==0) || 'Must Be a Number'
          },
          minLength: value => {            
            return value.length >= 2 || 'Must Be Longer'
          }
      },
      hoveringItem: "none",
      wonderousItems: [],
      showWonderousItemDialog:false,
      showWonderousItemTimer:{},
      wonderousItemTimers:[],
      hiddenDialog: {
        show:false,
        type:"",
        items:[],
      },
      gearTypes,
      allPerks: [...perks, ...roguePerks, ...fighterPerks, ...races, ...kiPerks, ...recoveryPerks],
      disciplineHelpDoc:false,
      maneuverDoc:false,
      spellMasteryDoc:false,
      showNewRoll: false,
      weaponHelpDoc: false,
      armorHelpDoc: false,
      newWeaponDialog: false,
      newWeapon: {
        name:"",
        damage:"",
        damageType:"",
        critical:"",
        notes:``

      },
      statsSettingsDoc: false,
      skillsList: skills,
      potionDialog:false,
      // alert:{},
      // showAlert:false,
      tab:0,
      gearTab:0,
      storeTab: 0,
      storeTabs:["character", "equipment", "perk","spells/maneuvers", "gear"],
      store:{visible:false, buying:true},      
      goldAmount:0,
      recentLevelUp: false,
      recentHpIncrease: 0,
      recentSpIncrease: 0,
      remainingRolls: [],
      statNames:['strength',"dexterity","constitution","intelligence","wisdom","charisma"],      
      potions:{
        curative:[],
        mnemonic:[],
        restorative:[],
        ressurective:[]
      },
      focusedPotion:{},
      newFocusedPotion:false,
      gear:[],
      groupNotes:``,
      gearList:false,
      focused:{
        maneuver:0,
        spells:0,
      },
      listNames: [
        "perks",
        "weapon",
        "armor",
        "wonderousItems",
        "feats",
        "spells",
        "maneuver",
      ],
      focus: {
        maneuverLevel: {},
        spellLevel: {},
        perks: {},
        gear: {},
        weapon: {},
        weaponEnchantments: {},
        armor: {},
        armorEnchantments: {},
        feats: {},
        spells: {},
        maneuver: {},
        wonderousItems:{},
      },
      stats: {
        lists: {
          perks: [],
          gear: [],
          weapon: [],
          armor: [],
          feats: [],
          spells: [],
          maneuver: [],
          wonderousItems:[],
        },
        statsForAbilities:{lvlForBab:false, atk:"strength", bonusAtk:0, dmg:"strength", bonusDmg:0, powerAttack:false, combatExpertise:false, cmb:"strength", size:"medium", ac:{abilityMod:"dexterity", armorCheckMod:0,deflection:0, armor:0,shield:0, natural:0,dodge:0,untyped:0,insight:0,sacred:0,size:0,luck:0,}}, 
        gold: 0,
        xp:0,
        nextLevel:500,
        xpLevel:0,
        notes:``,
        characterStats: {
          abilityScore: {
            strength: 10,
            dexterity: 10,
            constitution: 10,
            intelligence: 10,
            wisdom: 10,
            charisma: 10,
          },
          tempModifiers:{
            strength: 0,
            dexterity: 0,
            constitution: 0,
            intelligence: 0,
            wisdom: 0,
            charisma: 0,
            spellPoints:0,
            negativeLevels: 0,
            saves:0,
            fortitude:0,
            reflex:0,
            will:0,       
            cmb:0,
            cmd:0,    
            armorCheckPenalty: 0, 
            acrobatics: 0,
            diplomacy: 0,
            bluff: 0,
            climb: 0,
            disableDevice: 0,
            escapeArtist: 0,
            fly: 0,
            heal: 0,
            intimidate: 0,
            perception: 0,
            senseMotive: 0,
            spellcraft: 0,
            stealth: 0,
            perform: 0,
            survival: 0,
            knowArcana: 0,
            knowPlanes: 0,
            knowReligion: 0,
            knowNature: 0,
            craft: 0,
            swim:0,            
          },
          modifiedStats:{
            strength: 10,
            dexterity: 10,
            constitution: 10,
            intelligence: 10,
            wisdom: 10,
            charisma: 10,
          },
          misc: {
            class: "None",
            alignment:"None",
            level: 1,
            HDSize: 0,
            BAB: 0,
            fortitude: 0,
            reflex: 0,
            will: 0,
            hp: 0,
            hd: 0,
            spellpoints: 0,
            spPerLevel: 0,
            race: "None",
            combo:[]
          },
          skills: {
            acrobatics: 0,
            bluff: 0,
            climb: 0,
            craft: 0,
            diplomacy: 0,
            disableDevice: 0,
            escapeArtist: 0,
            fly: 0,
            heal: 0,
            intimidate: 0,
            knowArcana: 0,
            knowPlanes: 0,
            knowReligion: 0,
            knowNature: 0,
            perception: 0,
            perform: 0,
            senseMotive: 0,
            spellcraft: 0,
            stealth: 0,
            survival: 0,
            swim:0,
          },
          spellMastery:{
            spellPower:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
            spellCriticalChance:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
            spellCriticalDamage:{universal:50, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
            modifier:{
              spellPower:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
              spellCriticalChance:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
              spellCriticalDamage:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
            }
          },
          schoolMastery:{Air:0, Arcane:0, Curse:0, Dark:0, Death:0, Earth:0, Electricity:0, Fire:0, Flurry:0, Guardian:0, Heroic:0, Light:0, Power:0, Primal:0, Royal:0, Sakura:0, Shadow:0, Technique:0, Void:0, Water:0},
          spellpointIncreases:[],
          hpIncreases:[],
          investedEssence:0,
        },
      },
      notesPosition: { x: 20, y: 20 }, // Initial position
      isDragging: false,
      dragDelay:false,
      dragOffset: { x: 0, y: 0 }
    };
  },

  mounted() {
    if(!this.isGM){
      this.updateInterval = setInterval(()=>{
        this.sendCharacter()
      }, 1000 * 60 * 3)
    }
    if(this.isGM && this.tempCustomDialogs.length > 0){
      this.customDialogArray = this.tempCustomDialogs
    }
    window.addEventListener('keydown', this.keyPress, false)
    window.addEventListener('keyup', this.keyUp, false)
    if(window.innerHeight > window.innerWidth){
      alert("WARNING: The Character sheet is not built for portrait mode, please use landscape");
    }
    potionList.forEach((potion)=>{
      let tempPotion = JSON.parse(JSON.stringify(potion))
      tempPotion.count = 0
      if(potion.type == "curative"){
        this.potions.curative.push(tempPotion)
      }else if(potion.type == "mnemonic"){
        this.potions.mnemonic.push(tempPotion)
      }else if (potion.type == "restorative"){
        this.potions.restorative.push(tempPotion)
      }else if (potion.type == "ressurective"){
        this.potions.ressurective.push(tempPotion)
      }
    })    
  },


  destroyed (){
    window.removeEventListener('keydown', this.keyPress, false)
    window.removeEventListener('keyup', this.keyUp, false)
    clearInterval(this.updateInterval)
  },

  computed: {
    spellAugment(){
      let types = ["universal", "fire", "cold", "electricity", "acid", "positive", "negative"]
      let spellAugment = {spellPower:[], spellCriticalChance:[], spellCriticalDamage:[]}
      let item = this.focus.weapon
      types.forEach(type => {
        spellAugment.spellPower[type] = 0
        spellAugment.spellCriticalChance[type] = 0
        spellAugment.spellCriticalDamage[type] = 0
      })
      if(!item.id) return spellAugment
      console.log("item", item)
      if(item.spellPower){
        item.spellPower.forEach(power => { 
          spellAugment.spellPower[power.type] += parseInt(power.power)
        })
      }
      if(item.spellCriticalChance){
        item.spellCriticalChance.forEach(critical => {
          spellAugment.spellCriticalChance[critical.type] += parseInt(critical.power)
        })
      }
      if(item.spellCriticalDamage){
        item.spellCriticalDamage.forEach(damage => {
          spellAugment.spellCriticalDamage[damage.type] += parseInt(damage.power)
        })
      }
      if(item.enchantments){  
        item.enchantments.forEach(enchantment => {
          if(enchantment.spellCriticalChance){
            enchantment.spellCriticalChance.forEach(critical => {
              spellAugment.spellCriticalChance[critical.type] += parseInt(critical.power)
            })
          }
          if(enchantment.spellCriticalDamage){
            enchantment.spellCriticalDamage.forEach(damage => {
              spellAugment.spellCriticalDamage[damage.type] += parseInt(damage.power)
            })
          }
          if(enchantment.spellPower){
            enchantment.spellPower.forEach(power => {
              spellAugment.spellPower[power.type] += parseInt(power.power)
            })
          }
        })
      }
      return spellAugment
    },
    currentRoll() {
      if (this.remainingRolls.length > 0) {
        let roll = this.remainingRolls[0];
        return roll;
      } else if(this.tempPlayerRolls.length > 0){    
        this.tempPlayerRolls[0].options.forEach(option=>{
          option.uiType = this.tempPlayerRolls[0].type
        })
        return this.tempPlayerRolls[0]
      } else {
        let roll = {};
        return roll;
      }
    },

    spellLevels(){
      let levelArray = []
      this.stats.lists.spells.forEach((spell)=>{
        if(!spell.hidden){
          if(!levelArray.includes(spell.level)){
            levelArray.push(spell.level)
          }
        }
      })
      levelArray.sort(function(a, b){return a-b})
      return levelArray
    },

    maneuverLevels(){
      let levelArray = []
      this.stats.lists.maneuver.forEach((maneuver)=>{
        if(!maneuver.hidden){
          if(!levelArray.includes(parseInt(maneuver.level))){
            levelArray.push(parseInt(maneuver.level))
          }
        }
      })
      levelArray.sort(function(a, b){return a-b});
      return levelArray
    },

    spFromMental(){
      let stats = [Math.floor((this.stats.characterStats.modifiedStats.wisdom - 10)/2), Math.floor((this.stats.characterStats.modifiedStats.intelligence - 10)/2), Math.floor((this.stats.characterStats.modifiedStats.charisma - 10)/2)]
      let sortedStats = stats.sort(function(a, b){return b-a})
      let sp = sortedStats[0]/2
      return sp
    },

    abilityScores(){
        return Object.keys(this.stats.characterStats.abilityScore);
    },

    characterSkills(){
       return Object.keys(this.stats.characterStats.skills);
    },

    miscStats(){
      if(this.statsAlt){
        return ["hd","race","spPerLevel", "HDSize"]
      }else{
        return ["class","alignment","level","BAB","fortitude","reflex","will","hp","spellpoints"]
      }      
      //return Object.keys(this.stats.characterStats.misc);
    },

    hp(){
      let hpRolls = 0
      if(this.stats.characterStats.hpIncreases.length > 0){
        hpRolls = this.stats.characterStats.hpIncreases.reduce((a, b) => a + b)
      }      
      let conHp = (Math.floor((this.stats.characterStats.modifiedStats.constitution - 10)/2)) * this.stats.characterStats.hpIncreases.length       
      this.stats.lists.feats.filter(feat => feat.name == "Toughness" || feat.name == "Unstoppable").forEach(()=>{
        hpRolls += 5 + (this.stats.characterStats.hpIncreases.length * 2)
      })      
      hpRolls -= parseInt(this.stats.characterStats.tempModifiers.negativeLevels) * 5
      let totalHp = hpRolls
      if(this.stats.lists.feats.filter(feat => feat.name == "Greater Necromantic Affinity").length > 0){
        let stats = [Math.floor((this.stats.characterStats.modifiedStats.wisdom - 10)/2), Math.floor((this.stats.characterStats.modifiedStats.intelligence - 10)/2), Math.floor((this.stats.characterStats.modifiedStats.charisma - 10)/2)]
        let highest = stats.sort(function(a, b){return b-a})[0]
        totalHp += highest * this.stats.characterStats.hpIncreases.length
      }else{
        totalHp += conHp
      }
      return totalHp
    },

    spellpoints(){
      let stats = [Math.floor((this.stats.characterStats.modifiedStats.wisdom - 10)/2), Math.floor((this.stats.characterStats.modifiedStats.intelligence - 10)/2), Math.floor((this.stats.characterStats.modifiedStats.charisma - 10)/2)]
      let sortedStats = stats.sort(function(a, b){return b-a})
      let spellpoints = sortedStats[0]/2 * this.stats.characterStats.hpIncreases.length -1
      if(this.stats.characterStats.misc.spPerLevel == 0 || this.stats.characterStats.misc.spPerLevel){
        spellpoints += (this.stats.characterStats.misc.spPerLevel * ((this.stats.characterStats.hpIncreases.length) - Math.abs(parseInt(this.stats.characterStats.tempModifiers.negativeLevels))))       
      }else{
        spellpoints += 1 * (this.stats.characterStats.hpIncreases.length-1)
      }      
      spellpoints = Math.floor(spellpoints)
      let baseSpellpoints = sortedStats[1] + sortedStats[2] + sortedStats[0]
      this.stats.lists.feats.filter(feat => feat.name == "Arcane Link").forEach(()=>{
        spellpoints += (this.stats.characterStats.misc.level-1 *3) + 6
      })
      let spellPointIncreases = 0 
      this.stats.characterStats.spellpointIncreases.forEach(increase =>{
        spellPointIncreases += increase
      })
      this.stats.lists.perks.forEach(perk =>{
        if(perk.name == "Rage" || perk.name == "Enduring Rage"){
          spellPointIncreases += (Math.floor((this.stats.characterStats.abilityScore.constitution - 10)/2) * (Math.floor(this.stats.characterStats.misc.level/6)+1))
        }
      })
      let total = spellpoints + baseSpellpoints + spellPointIncreases
      if(this.stats.characterStats.investedEssence) total -= this.stats.characterStats.misc.level * this.stats.characterStats.investedEssence
      if(this.stats.characterStats.tempModifiers.spellPoints) total += parseInt(this.stats.characterStats.tempModifiers.spellPoints)
      return total
    },
    
    cmb(){      
      let bab = this.stats.statsForAbilities.lvlForBab ? parseInt(this.stats.characterStats.misc.level) : this.stats.characterStats.misc.BAB       
      return this.tempModifier(this.stats.statsForAbilities.cmb) + bab + parseInt(this.stats.characterStats.tempModifiers.cmb) - Math.abs(parseInt(this.stats.characterStats.tempModifiers.negativeLevels))
    },

    cmd(){      
      let bab = this.stats.statsForAbilities.lvlForBab ? parseInt(this.stats.characterStats.misc.level) : this.stats.characterStats.misc.BAB     
      return this.tempModifier("strength") + this.tempModifier(this.stats.statsForAbilities.ac.abilityMod) + bab + 10 + parseInt(this.stats.characterStats.tempModifiers.cmd) + parseInt(this.stats.statsForAbilities.ac.deflection) + parseInt(this.stats.statsForAbilities.ac.dodge) + parseInt(this.stats.statsForAbilities.ac.insight) + parseInt(this.stats.statsForAbilities.ac.sacred) + parseInt(this.stats.statsForAbilities.ac.luck) - parseInt(this.stats.statsForAbilities.ac.size)
    },  

    maneuverInfo(){
      //comboTagsWithExtra
      let tagInfo = []
      let obj = {count:0,types:{Strike:0,Boost:0,Counter:0,Stance:0},levels:[],id:Math.random(),mastery:0}
      for(let x = 0; x < 10; x++){
        obj.levels[x] = {level:x,count:0}
      }
      obj = JSON.stringify(obj)

      this.comboTagText.concat(['elementalFlux','solarWind']).forEach(comboTag=>{
        let tempObj = JSON.parse(obj)
        tempObj.name = comboTag
        tempObj.id = Math.random()
        tagInfo.push(tempObj)
      })

      this.stats.lists.maneuver.forEach(maneuver=>{
        if(maneuver.type != "Finisher"){
          let tags = []
          if(maneuver.school == "solarWind") tags = [maneuver.school]
          else if(maneuver.school == "elementalFlux") tags = ["elementalFlux","Arcane"]
          else tags = this.comboTags[maneuver.school]
          if(maneuver.additionalTags) tags = tags.concat(maneuver.additionalTags)
          if(tags.length > 0){ 
            tags.forEach(tag=>{
              let db = tagInfo.find(tagDb=> tagDb.name == tag)
              db.count += 1
            db.types[maneuver.type] += 1
            let mastery = parseInt(maneuver.level)
            if(db.levels[maneuver.level].count == 0) mastery *= 2
            if(mastery > 9) mastery = 9
            if(tag == "elementalFlux") mastery = Math.ceil(mastery/2)
            db.mastery += mastery + this.stats.characterStats.schoolMastery[tag]
            db.levels[maneuver.level].count += 1
          })
        }
        }
      })
      if(this.comboSortBy != "Alphabetic"){
        tagInfo = tagInfo.sort(function(a, b){return b.mastery-a.mastery})
      }
      return tagInfo


      // let generalInfo = []
      // let levelsInfo = []
      // let disciplineInfo = []
      // this.stats.lists.maneuver.forEach(maneuver=>{
      //   if(maneuver.type != "Finisher"){
      //     let existingSchool = disciplineInfo.find(discipline=>discipline.name == maneuver.school) 
      //     if(existingSchool){
      //       existingSchool.count += 1
      //       existingSchool.levels[maneuver.level] += 1

      //       let existingType = existingSchool.types.find(type=>type.type == maneuver.type) 
      //       if(existingType){
      //         existingType.count += 1
      //       }else{
      //         let details = {type:maneuver.type,count:1}
      //         existingSchool.types.push(details)
      //       }
      //     }else{
      //       let details = {name:maneuver.school,count:1,levels:[],types:[]}
      //       for(let x = 0; x < 10; x++){
      //         details.levels[x] = 0
      //       }
      //       details.levels[maneuver.level] = 1
      //       details.types.push({type:maneuver.type,count:1})
      //       disciplineInfo.push(details)
      //     }

      //     let existingGeneral = generalInfo.find(general=>general.name == maneuver.type)
      //     if(existingGeneral){
      //       existingGeneral.count += 1
      //     }else{
      //       let details = {name:maneuver.type,count:1}
      //       generalInfo.push(details)
      //     }

      //     let existingLevel = levelsInfo.find(level=>level.num == maneuver.level)
      //     if(existingLevel){
      //       existingLevel.count += 1
      //     }else{
      //       let details = {num:maneuver.level,count:1}
      //       levelsInfo.push(details)
      //     }
      //   }
      // })
      // return {generalInfo,levelsInfo,disciplineInfo}
    },
    spellMastery(){
      return this.stats.characterStats.spellMastery
    }
  },
  watch: {    
    newRoll() {
      if(this.firstSend){
        this.sendCharacter()
        this.firstSend = false
      }
      if (this.newRoll != "none") {
        let newRoll = this.newRoll;
        this.showNewRoll = true
        if(this.newRoll.type == 'requestWeapon'){
          if(this.stats.lists.weapon.length > 0){
            let weapons = []
            let classes = Object.entries(newRoll.data.class).filter((entry)=> entry[1] == true).map(item => item[0])
            this.stats.lists.weapon.forEach((weapon)=>{
              if(classes.includes(weapon.class) && weapon.name != "Rock" && weapon.name != "Unarmed" && weapon.type != "custom"){
                weapon.uiType = 'weapon'  
                weapons.push(weapon)
              }
            })
            if(weapons.length <= 0){
              return
            }
            newRoll.options = weapons
          }else{
            return
          }
        } else if(this.newRoll.type == 'class'){
          if(this.stats.characterStats.misc.class != "None"){
            return
          }else{
            newRoll.options.forEach((option) => {
              option.uiType = newRoll.type;
            })
          }
        }else if(this.newRoll.type == 'armorEnchantments'){
          if(this.stats.lists.armor.length > 0){
            newRoll.options.forEach((option) => {
              option.uiType = this.newRoll.type
            });
            let newGetArmorRoll = {}
            let armors = []
            this.stats.lists.armor.forEach((armor)=>{
              if(armor.name != "Unarmored"){
                armor.uiType = 'armor'
                armors.push(armor)          
              }
            })
            newGetArmorRoll.options = armors
            newGetArmorRoll.type = "armorForEnchantment"
            newGetArmorRoll.enchantmentOptions = newRoll
            this.remainingRolls.push(newGetArmorRoll)
            if(this.tempPlayerRolls) this.remainingRolls.push(newRoll)
            return
          }else{
            return
          }
        } else if(this.newRoll.type == 'levelUp'){          
          this.stats.characterStats.misc.level += 1
          this.stats.characterStats.misc.hd += 1
          let classBonuses = classRoll.find(classRoll => classRoll.name == this.stats.characterStats.misc.class)
          if(this.stats.characterStats.misc.class != 'None')
          classBonuses.bonusRolls(this,classBonuses)
          this.recentLevelUp = true
          let hpIncrease = Math.ceil(Math.random() * this.stats.characterStats.misc.HDSize)
          this.stats.characterStats.hpIncreases.push(hpIncrease)
          this.recentHpIncrease = hpIncrease
          let stats = [Math.floor((this.stats.characterStats.abilityScore.wisdom - 10)/2), Math.floor((this.stats.characterStats.abilityScore.intelligence - 10)/2), Math.floor((this.stats.characterStats.abilityScore.charisma - 10)/2)]
          let heighestMental = stats.sort(function(a, b){return b-a})[0];
          this.recentSpIncrease = Math.floor(heighestMental/2 + this.stats.characterStats.misc.spPerLevel)
          for(let x = 0; x < this.stats.lists.perks.length; x++){
            if(this.stats.lists.perks[x].hasCustomMethod){
              let foundPerk = this.allPerks.filter(perk=>perk.name==this.stats.lists.perks[x].name)[0]
              foundPerk.customMethod(this, foundPerk, this.stats.lists.perks[x])
            }
          }
          this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats}))
          return
        } else if(this.newRoll.type == 'gold'){
          let goldSound = new Audio(goldDrop)
          goldSound.volume = 0.33
          goldSound.play()
          this.stats.gold += parseInt(this.newRoll.amount)
          if(this.newRoll.info){
            let filtered = this.stats.lists.perks.filter(perk =>{
              return perk.name == "Treasure Sense"
            })
            filtered.forEach(()=>{            
              let multiplier = this.newRoll.info == "small" ? 10 : this.newRoll.info == "medium" ? 20 : 30
              this.stats.gold += Math.ceil(Math.random()*multiplier)
            })
            if(this.stats.lists.perks.filter(perk => perk.name == "Rogue's Luck").length > 0){
              let multiplier = this.newRoll.info == "small" ? 1 : this.newRoll.info == "medium" ? 2 : 3
              for(let x = 0; x < multiplier; x++){
                this.stats.gold += Math.ceil(Math.random()*6)
              }
            }
          }
          this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats}))
          return
        }else if(this.newRoll.type == 'xp'){
          if(this.stats.lists.perks.filter(perk => perk.name == "Fast Learner").length > 0){
            this.newRoll.amount = parseInt(this.newRoll.amount) * 1.1
          }
          this.stats.xp += parseInt(this.newRoll.amount)
          while(this.stats.xp >= this.stats.nextLevel){
            if(!this.newRoll.ignoreLeveling){
              this.connection.send(JSON.stringify( {command:"requestRoll", type:"Level Up"}))
            }
            this.stats.xp = parseInt(this.stats.xp) - parseInt(this.stats.nextLevel)
            this.stats.nextLevel = Math.floor(this.stats.nextLevel * (1.3 + (0.0301 * this.stats.xpLevel)))
            this.stats.xpLevel++            
          }
          this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats}))
          return
        }else if(this.newRoll.type == 'newStore'){
          this.store.visible = true
          this.store.open = true
          this.store.itemTypes = []
          this.store.playerNames = this.newRoll.playerNames
          this.newRoll.remainingItems.forEach(item=>{
            if(item.type && this.store.itemTypes.filter(itemType=>{return itemType.type == item.type}).length == 0){
              this.store.itemTypes.push({type:item.type, storeType:item.storeType})
            } else if(this.store.itemTypes.filter(itemType=>{return itemType.type == item.name}).length == 0 && !item.type){
              this.store.itemTypes.push({type:item.name, storeType:item.storeType})              
            }
          })
          this.store.remainingItems = this.newRoll.remainingItems
          this.store.sellableItems = []
          this.stats.lists.weapon.forEach((weapon)=>{
            if(weapon.name != "Rock" && weapon.name != "Unarmed" && weapon.type != "custom"){
              let newSellableItem = {}
              newSellableItem.id = this.store.sellableItems.length
              newSellableItem.price = this.getItemSellPrice(weapon)
              newSellableItem.item = weapon
              this.store.sellableItems.push(newSellableItem)
            }            
          })
           this.stats.lists.armor.forEach((armor)=>{
            if(armor.name != "Unarmored"){
              let newSellableItem = {}
              newSellableItem.id = this.store.sellableItems.length
              newSellableItem.price = this.getItemSellPrice(armor)
              newSellableItem.item = armor
              this.store.sellableItems.push(newSellableItem)
            }
          })
          this.stats.lists.wonderousItems.forEach((item)=>{
            let newSellableItem = {}
            newSellableItem.id = this.store.sellableItems.length
            newSellableItem.price = this.getItemSellPrice(item)
            newSellableItem.item = item
            this.store.sellableItems.push(newSellableItem)
          })
          return
        }else if(this.newRoll.type == 'closeStore'){
          this.store.remainingItems = []
          this.store.open = false
          this.store.visible = false
          return
        }else if(this.newRoll.type == 'wonderousItems' && this.newRoll.clearItem){          
          let index = this.wonderousItems.findIndex(item=> item.item.id == this.newRoll.clearItem)
          if(index != -1){
            clearInterval(this.wonderousItems[index].interval)
            this.wonderousItems.splice(index,1)
            if(this.wonderousItems.length == 0) this.showWonderousItemDialog = false
          }          
          if(this.newRoll.options){
            newRoll.options.forEach((option) => {
              option.uiType = newRoll.type;
            })
          }else{
            return
          }
        }else {
          newRoll.options.forEach((option) => {
            option.uiType = newRoll.type;
          })
        }
        this.remainingRolls.push(newRoll)
      }
    },
    customDialogArray(){
      if(this.customDialogArray.length > 0){
        this.customDialog = {visible:true,title:this.customDialogArray[0].title,options: this.customDialogArray[0].options}
        if(!this.isGM){
          this.connection.send(JSON.stringify({command:"CustomDialogs", data:this.customDialogArray}))
        }
      }else{
        this.customDialog = {visible:false}
      }
      
    },
    customSpellArray(){
      console.log("ran", this.customSpellArray)
      if(this.customSpellArray.length > 0){
        this.customSpellDialog = {
          visible:true,
          title:this.customSpellArray[0].title,
          text: this.customSpellArray[0].text,
          maxLength: this.customSpellArray[0].maxLength || 15,
          level: this.customSpellArray[0].level || 1}
      }else{
        this.customSpellDialog = {visible:false}
      }
    },
    tempCustomDialogs(){
      this.customDialogArray = this.tempCustomDialogs
    },

    setCharacter(){
      this.runSetCharacter(this.setCharacter.data)
    },

    communalUpdate(){
      let update = this.communalUpdate
      if(update.type=="potion"){
        let epotion = this.potions[update.potion.type].find(potion=>potion.id == update.potion.id)
        epotion.count = update.potion.count
      }else if(update.type == 'storeItemBought'){
          let boughtItem = this.store.remainingItems[update.itemId]
          boughtItem.boughtBy = update.boughtBy
          this.store.remainingItems.splice(update.itemId, 1, boughtItem)
          return
        }else if(update.type == "gear"){
          let index = this.gear.findIndex(gear=> gear.name == update.gear.name)
          if(index == -1){
            this.gear.splice(0,0, update.gear)
            this.newGearCounts[update.gear.type] += 1
          }else{
            let temp = this.gear[index]
            if(update.gear.count > temp.count){
              this.newGearCounts[update.gear.type] += 1
            }
            temp.count = update.gear.count
            this.gear.splice(index,1,temp)
          }
        }else if(update.notes){
          this.groupNotes = update.notes
        }else if(update.type == "wonderousItem"){
          let itemSound 
          if(update.item.rarity == "unique" || update.item.rarity == "legendary") itemSound = new Audio(rareItem)
          else itemSound = new Audio(itemDrop)        
          itemSound.volume = 0.33
          itemSound.play()
          let wonderousObj = {item:update.item,interval:{},intervalCount:60, roll:-1}
          this.wonderousItems.push(wonderousObj)
          this.showWonderousItemDialog = true
          wonderousObj.interval = setInterval(()=>{
            wonderousObj.intervalCount -= 1
            if(wonderousObj.intervalCount == 0){
              let index = this.wonderousItems.findIndex(indexItem => indexItem.item.id == wonderousObj.item.id)              
              clearInterval(this.wonderousItems[index].interval)
              this.wonderousItems.splice(index,1)
              if(this.wonderousItems.length == 0) this.showWonderousItemDialog = false
            }
          }, 1000)
        }
    },
    
    weaponHelpDoc(){
      if(this.weaponHelpDoc == false){
        if(!parseInt(this.stats.statsForAbilities.bonusAtk)){
          this.stats.statsForAbilities.bonusAtk = 0
        }
        if(!parseInt(this.stats.statsForAbilities.bonusDmg)){
          this.stats.statsForAbilities.bonusDmg = 0
        }
        this.sendCharacter()
      }
    },
    
    armorHelpDoc(){// armorCheckMod:0,deflection:0, armor:0,shield:0, natural:0,dodge:0,untyped:0
      if(this.armorHelpDoc == false){
        if(!this.statNames.includes(this.stats.statsForAbilities.ac.abilityMod) || this.stats.statsForAbilities.ac.abilityMod == "none"){
          this.stats.statsForAbilities.ac.abilityMod = "dexterity"
        }
        Object.entries(this.stats.statsForAbilities.ac).forEach(stat=>{
          if(!parseInt(stat[1]) && stat[0] != "abilityMod"){
            this.stats.statsForAbilities.ac[stat[0]] = 0
          }
        })
        this.sendCharacter()
      }
    },    

    'stats.characterStats.tempModifiers':{
      handler : function(){
        this.statNames.forEach(stat=>{     
          this.stats.characterStats.modifiedStats[stat] = parseInt(this.stats.characterStats.abilityScore[stat]) + parseInt(this.stats.characterStats.tempModifiers[stat])         
        })
      },
      deep:true
    },
    

    'stats.characterStats.abilityScore':{
      handler: function(){
        this.statNames.forEach(stat=>{     
          this.stats.characterStats.modifiedStats[stat] = parseInt(this.stats.characterStats.abilityScore[stat]) + parseInt(this.stats.characterStats.tempModifiers[stat])         
        })
      },
      deep:true
    },

    tempPlayerRolls(){
      //this.tempPlayerRolls.splice(0,1)
    },

    statsSettingsDoc(){
      if(this.statsSettingsDoc == false){
        if(!this.statNames.includes(this.stats.statsForAbilities.cmb)){
          this.stats.statsForAbilities.cmb = "strength"
        }
        Object.keys(this.stats.characterStats.tempModifiers).forEach(statName =>{
          if(parseInt(this.stats.characterStats.tempModifiers[statName]) || this.stats.characterStats.tempModifiers[statName] == "0"){
            if(this.statNames.includes(statName)){
              this.stats.characterStats.modifiedStats[statName] = parseInt(this.stats.characterStats.abilityScore[statName]) + parseInt(this.stats.characterStats.tempModifiers[statName])
            }
          }else{
            this.stats.characterStats.tempModifiers[statName] = 0
          }
        })        
        // Object.keys(this.stats.characterStats.tempModifiers).forEach(statName=>{
        //   if(!parseInt(this.stats.characterStats.tempModifiers[statName])){
        //     this.stats.characterStats.tempModifiers[statName] = 0
        //   }
        // })
        this.sendCharacter()
      }
    },    
  },

  methods: {
    createSpell(){
      let perk = this.allPerks.find(perk=>perk.name == "Magical Savant")
      if(perk){
        perk.generateNewSpell(this, this.customSpellDialog)
        this.$nextTick(()=>{
          this.customSpellArray.splice(0,1)
        })        
      }
    },
    updateNewGearCounts(gearType){
      console.log(gearType, this.newGearCounts[gearType])
      this.newGearCounts[gearType] = 0
    },
    copySpellRoll(spellType){
      let string = "!s damage," + this.spellMasteryParser(spellType, "spellPower", "total") + "," + this.spellMasteryParser(spellType, "spellCriticalChance", "total") + "," + this.spellMasteryParser(spellType, "spellCriticalDamage", "total")
      navigator.clipboard.writeText(string);
    },
    trigger(statType, spellType){
      if(isNaN(this.stats.characterStats.spellMastery.modifier[statType][spellType])){
        this.stats.characterStats.spellMastery.modifier[statType][spellType] = 0
      }
    },
    spellMasteryParser(spellType, statType, returnType){
      let returnValue = this.stats.characterStats.spellMastery[statType][spellType] + parseInt(this.stats.characterStats.spellMastery.modifier[statType][spellType])

      returnValue += this.getSkillBonusToPower(statType, spellType)

      if(this.includeEquippedWeapons){
        returnValue += this.spellAugment[statType][spellType]
      }


      if(spellType != 'universal' && returnType == 'total'){
        returnValue += this.stats.characterStats.spellMastery[statType].universal + parseInt(this.stats.characterStats.spellMastery.modifier[statType].universal) 
        if(this.includeEquippedWeapons){
          returnValue += this.spellAugment[statType].universal
        }
      }
      return returnValue
    },
    getSkillBonusToPower(statType, spellType){
      if(spellType == "universal") return 0
      let bonus = this.skillToSpellBonus[statType][spellType]
      return Math.floor(this.stats.characterStats.skills[bonus.skill] * bonus.rate)
    },
    enableStickyNotes() {
      this.stickyNotes = true;
      // Set initial position at bottom left
      this.notesPosition = { x: 16, y: window.innerHeight - 416 };
    },
    startDrag(event) {
      // Only drag from the title bar
      if (event.target.id == "stickyNotes" && this.isDragging == false) {
        this.isDragging = true;
        
        // Get mouse or touch position
        const clientX = event.clientX || (event.touches && event.touches[0].clientX);
        const clientY = event.clientY || (event.touches && event.touches[0].clientY);
        
        // Calculate offset from the current transform position
        this.dragOffset = {
          x: clientX - this.notesPosition.x,
          y: clientY - this.notesPosition.y
        };
        
        // Add move and end event listeners with proper binding
        window.addEventListener('mousemove', this.onDrag, { passive: false });
        window.addEventListener('touchmove', this.onDrag, { passive: false });
        window.addEventListener('mouseup', this.stopDrag);
        window.addEventListener('touchend', this.stopDrag);
        
        // Prevent default to avoid text selection during drag
        event.preventDefault();
      }
    },
    onDrag(event) {
      if (!this.isDragging || this.dragDelay) return;
      // Get mouse or touch position
      const clientX = event.clientX || (event.touches && event.touches[0].clientX);
      const clientY = event.clientY || (event.touches && event.touches[0].clientY);
      
      // Update position using transform
      this.notesPosition = {
        x: clientX - this.dragOffset.x,
        y: clientY - this.dragOffset.y
      };
      setTimeout(()=>{
        this.dragDelay = false
      }, 10)
      this.dragDelay = true

      // Prevent default to avoid text selection during drag
      event.preventDefault();
    },
    stopDrag() {
      this.isDragging = false;
      
      // Remove event listeners
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('touchmove', this.onDrag);
      window.removeEventListener('mouseup', this.stopDrag);
      window.removeEventListener('touchend', this.stopDrag);
    },
    keyPress(e){
      if(e.code == "ArrowRight") this.goNext()
      else if(e.code == "ArrowLeft") this.goPrevious()
      else if(e.code == "ArrowDown") this.sortDown()
      else if(e.code == "ArrowUp") this.sortUp()
      else if(e.shiftKey) this.shiftDown = true
      else if(e.ctrlKey) this.ctrlDown = true
      else if(e.altKey) {
        this.altDown = true; 
      }
    },
    keyUp(e){
      if(!e.shiftKey && this.shiftDown == true) this.shiftDown = false
      if(!e.ctrlKey && this.ctrlDown == true)  this.ctrlDown = false
      if(!e.altKey && this.altDown == true)  this.altDown = false
    },
    borderColor(item){
      if(item.investedEssence > 0 && item.favorite) return "rgb(17, 194, 4)"
      if(item.investedEssence > 0) return "rgb(3, 219, 252)"
      if(item.favorite) return "rgb(250, 217, 5)"
      if(item.expended) return "rgb(250, 5, 5)"
      let rarity = item.rarity
      if(rarity){
        if(rarity =="common") return "rgb(40,39,40)"
        else if(rarity =="rare") return "rgb(13,20,27)"
        else if(rarity =="epic") return "rgb(43,17,53)"
        else if(rarity =="legendary") return "rgb(40,25,0)"
        else if(rarity =="unique") return "rgb(32,17,14)"
        else return "rgb(144,144,144)"
      } else return "rgb(144,144,144)"
    },
    getColorClass(item){   
      if(item.rarity == "common") return "pickerCardGray"
      else if(item.rarity == "rare") return "pickerCardBlue"
      else if(item.rarity == "epic") return "pickerCardPurple"
      else if(item.rarity == "legendary") return "pickerCardOrange"
      else if(item.rarity == "unique") return "pickerCardRed"
      else if(item.rarity == "none") return "pickerCardWhite"
      else if(item.rarity == "forbidden") return "pickerCardBlack"
      else return "pickerCardWhite"
    },
    getColor(rarity){
      if(rarity){
        if(rarity =="common") return "grey"
        else if(rarity =="rare") return "blue"
        else if(rarity =="epic") return "purple"
        else if(rarity =="legendary") return "orange"
        else if(rarity =="unique") return "red"
        else if(rarity =="forbidden") return "black"
        else if(rarity =="class") return "cyan"
        else return "white"
      }
    },
    isMozilla(){
      return navigator.userAgent.search("Firefox") > 1
    },
    runSetCharacter(data){      
      this.stats = data      
      while(this.stats.xp >= this.stats.nextLevel){
        this.connection.send(JSON.stringify( {command:"requestRoll", type:"Level Up"}))        
        this.stats.xp = parseInt(this.stats.xp) - parseInt(this.stats.nextLevel)
        this.stats.nextLevel = Math.floor(this.stats.nextLevel * (1.3 + (0.0301 * this.stats.xpLevel)))
        this.stats.xpLevel++            
      }
    },
    maybeOpenNewTab(item){
      if(this.altDown && item.hasSpecialItems){
        this.altDown = false
        let urlType = "Perks"
        if(item.rarity == "class") urlType = "Races"
        window.open("https://www.akashicpaths.com/rules/gameitems?type=" + urlType + "&perkList=" + item.name, '_blank').focus()
        return
      }
    },

    select(option) {
      if(this.altDown && option.hasSpecialItems){
        this.altDown = false
        let urlType = "Perks"
        if(option.rarity == "class") urlType = "Races"
        window.open("https://www.akashicpaths.com/rules/gameitems?type=" + urlType + "&perkList=" + option.name, '_blank').focus()
        return
      }
      option.uiType = this.remainingRolls[0].type;
      if (option.uiType == "stats") {
        this.addStats(option)
        let response = { type: "selected", option: option, rollId:this.remainingRolls[0].rollId };        
        this.connection.send(JSON.stringify(response));
        this.remainingRolls.splice(0, 1);
      } else if (option.uiType == "class") {
        this.setClass(option)
      }else if(option.uiType =="race"){
        this.stats.characterStats.misc.race = option.name
        this.stats.lists.perks.push(option)
        if(option.hasCustomMethod){
            let foundPerk = this.allPerks.filter(perk=>perk.name==option.name)[0]
            if(foundPerk.catchUpMethod){
              foundPerk.catchUpMethod(this, foundPerk, option)
            }
        }
        let response = { type: "selected", option: option, rollId:this.remainingRolls[0].rollId};        
        this.connection.send(JSON.stringify(response));
        this.remainingRolls.splice(0, 1);
      }else if(this.remainingRolls[0].type == "requestWeapon"){
        let request = {};
        request.command = "requestWeaponEnchantment";
        request.type = 'requestWeaponEnchantment';
        request.weapon = option
        request.options = this.remainingRolls[0].data;        
        this.connection.send(JSON.stringify(request));
        this.remainingRolls.splice(0, 1);
      }else if(this.remainingRolls[0].type == "weaponEnchantment"){
        let weapon = this.stats.lists.weapon.find(weapon=> weapon.id == this.remainingRolls[0].weapon.id)
        weapon.enchantments.push(option)
        let response = { type: "selected", option: option, rollId:this.remainingRolls[0].rollId };
        this.connection.send(JSON.stringify(response));
        this.remainingRolls.splice(0, 1);
        this.setFocus("weapon", "null")
      } else if(this.remainingRolls[0].type == "armorForEnchantment"){
        this.remainingRolls[0].enchantmentOptions.selectedArmor = option
        this.remainingRolls.splice(1,0,this.remainingRolls[0].enchantmentOptions)
        this.remainingRolls.splice(0,1);
      }else if(this.remainingRolls[0].type == "armorEnchantments"){
        let armor = this.stats.lists.armor.find(armor=> armor.id == this.remainingRolls[0].selectedArmor.id)
        armor.enchantments.push(option)
        let response = { type: "selected", option: option, rollId:this.remainingRolls[0].rollId }
        this.connection.send(JSON.stringify(response))
        this.remainingRolls.splice(0, 1);
        this.setFocus("armor", "null")
      }else if(this.remainingRolls[0].type == "feats" && option.type == "teamwork" && option.playerNames){
        this.remainingRolls[0].new = false

        let response = { type: "selected", option: option, rollId:this.remainingRolls[0].rollId }
        this.connection.send(JSON.stringify(response))
        
        let newRoll = {}
        newRoll.type = "selectTeamworkPartner"
        newRoll.options = []
        newRoll.rollId = this.remainingRolls[0].rollId
        newRoll.feat = option
        option.playerNames.forEach(player => {
          let newOption = {}
          newOption.rollId = Math.random()*100000000
          newOption.feat = option
          newOption.uiType = "player"       
          newOption.playerName = player   
          newRoll.options.push(newOption)  
        })        
        if(newRoll.options.length > 0){
          newRoll.new = true
          this.remainingRolls.splice(0, 1)
          this.remainingRolls.unshift(newRoll)
        }
        
      }else if(this.remainingRolls[0].type == "selectTeamworkPartner"){
        let response = {}
        response.command = "giveTeamworkFeat"
        response.feat = option.feat
        response.player = option.playerName
        this.stats.lists.feats.push(option.feat)
        this.connection.send(JSON.stringify(response))
        option.feat.to = option.playerName
        this.remainingRolls.splice(0, 1)
      }else if(this.remainingRolls[0].type == "alignment"){
        this.stats.characterStats.misc.alignment = option.name
        let response = { type: "selected", option: option, rollId:this.remainingRolls[0].rollId }
        this.connection.send(JSON.stringify(response));
        this.remainingRolls.splice(0, 1);
      } else if(this.remainingRolls[0].type == "weapon"){               
        this.stats.lists[this.remainingRolls[0].type].push(option);
        let response = { type: "selected", option: option, rollId:this.remainingRolls[0].rollId }
        this.connection.send(JSON.stringify(response));
        this.remainingRolls.splice(0, 1);
      } else {
        this.stats.lists[this.remainingRolls[0].type].push(option)
        if(option.hasCustomMethod){
          let foundItem
          if(option.uiType == "perks"){
            foundItem = this.allPerks.filter(perk=>perk.name==option.name)[0]
          }else if(option.uiType == "feats"){
            foundItem = feats.filter(feat=>feat.name==option.name)[0]
          }
            if(foundItem.catchUpMethod){
              foundItem.catchUpMethod(this, foundItem, option)
            }
        }
        let response = { type: "selected", option: option, rollId:this.remainingRolls[0].rollId };
        this.connection.send(JSON.stringify(response));
        this.remainingRolls.splice(0, 1);
      }
      this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats}))
    },

    getClassName(name){
    if(levelUpPerks[name.toLowerCase()]){
        return name.toLowerCase()
    }else{
        if(name=="Eldritch Knight") return "eldritchKnight"
        else if(name=="Arcane Trickster") return "arcaneTrickster"
    }
  },

    async setClass(option){
      if(this.username && this.password){
        let className = this.getClassName(option.name)
        await this.getClassDetails(className)
          let classPerks = levelUpPerks[className]
          for(let x = 0; x < this.accountPerks.level; x++){
            let tier = x+1
            let perkID = this.accountPerks["tier" + tier]
            if(perkID != 0){
              let perk = classPerks["tier" + tier].find(obj=>obj.id == perkID)
              perk.method(option, this)
            }
          }
        }
        let dbClass = classRoll.find(roll=> roll.name == option.name)
        dbClass.customMethod(this,dbClass)
        this.stats.lists.weapon.splice(0,0,{id:"1", name: "Rock", rarity: "none", class: "ranged", uiType:"weapon", enchantments:[],  type: "ranged", damage: "1", damageType:"B", crit: "x2", range: "10 ft", special: "This weapon represent a pile of throwing weapons so you can throw as many as needed.", statsForAbilities:{atkStat:"dexterity",  bonusAtk:0,  dmgStat:"strength",  bonusDmg:0,  dieSteps:0,},})
        this.stats.lists.weapon.splice(0,0,{id:"2", name: "Unarmed", rarity: "none", class: "melee", uiType:"weapon", enchantments:[],  type: "light", damage: "1d4", damageType:"B", crit: "x2", range: "-", special: "Without the improved unarmed strike feat or flurry of blows perk attacking unarmed provokes an attack of opportunity", statsForAbilities:{atkStat:"strength",  bonusAtk:0,  dmgStat:"strength",  bonusDmg:0,  dieSteps:0,},})      
        this.stats.lists.armor.splice(0,0,{id:"3", name: "Unarmored", uiType:"armor", type: "armor",armorBonus: "0", enchantments:[],maxDex: "-",armorCheck: "-",rarity:"none",},)
        this.stats.characterStats.misc.class = option.name
        this.stats.characterStats.misc.level = 1
        this.stats.characterStats.spellpointIncreases.push(option.baseStatsMods.sp)
        this.stats.characterStats.misc.spPerLevel = option.baseStatsMods.spPerLevel
        this.stats.characterStats.misc.HDSize = option.baseStatsMods.hdSize
        this.stats.characterStats.misc.hd += 1
        this.stats.characterStats.hpIncreases.push(option.baseStatsMods.hdSize)
        this.stats.characterStats.misc.fortitude = parseInt(option.baseStatsMods.fortitude)
        this.stats.characterStats.misc.reflex = parseInt(option.baseStatsMods.reflex)
        this.stats.characterStats.misc.will = parseInt(option.baseStatsMods.will)
        this.stats.characterStats.misc.BAB = parseInt(option.baseStatsMods.bab)
        this.stats.gold = parseInt(option.baseStatsMods.gold)
        Object.keys(option.baseStatsMods.abilityScores).forEach(abilityScore =>{
          this.stats.characterStats.abilityScore[abilityScore] += parseInt(option.baseStatsMods.abilityScores[abilityScore])
        })
        this.connection.send(JSON.stringify({command:"requestRoll", type:"alignment"}));
        this.connection.send(JSON.stringify({command:"requestRoll", type:"race"}));
        option.rollRequests.forEach(rollRequest=>{
          for (let y = 0; y < rollRequest.amount; y++) {
            let request = {};
            request.command = "requestRoll";
            request.type = rollRequest.type;
            if(rollRequest.options){
              request.options = rollRequest.options
            }
            this.connection.send(JSON.stringify(request));
          }
        })        
        let response = { type: "selected", option: option, rollId:this.remainingRolls[0].rollId };
        this.connection.send(JSON.stringify(response));        
        this.remainingRolls.splice(0, 1);
    },

    addStats(option){
      this.stats.characterStats[option.type][option.stat] += option.bonus;
        if(option.drawback){
          this.stats.characterStats.abilityScore[option.drawback] += option.penalty;
        }
        if(option.stat == 'hd'){
          for(let x = 0; x < option.bonus; x++){
            this.stats.characterStats.hpIncreases.push( Math.ceil(Math.random() * this.stats.characterStats.misc.HDSize))
          }
        }else if(option.stat == 'spellpoints'){
          this.stats.characterStats.misc.spPerLevel += parseInt(option.bonus)
        }
    },

    goNext(){
      if(this.tempPlayerRolls && this.tempPlayerRolls.length > 1){
        let roll = this.tempPlayerRolls.splice(0, 1)[0];
        this.tempPlayerRolls.push(roll);
      }else if(this.remainingRolls && this.remainingRolls.length > 1){
        let roll = this.remainingRolls.splice(0, 1)[0];
        this.remainingRolls.push(roll);
      }
    },
    goPrevious(){
      if(this.tempPlayerRolls && this.tempPlayerRolls.length > 1){
        let roll = this.tempPlayerRolls.splice(this.tempPlayerRolls.length-1, 1)[0];
        this.tempPlayerRolls.unshift(roll);
      }else if(this.remainingRolls && this.remainingRolls.length > 1){
        let roll = this.remainingRolls.splice(this.remainingRolls.length-1, 1)[0];
        this.remainingRolls.unshift(roll);
      }
    },

    sortUp(){
      if(this.recentFocus.item){
        let index = this.stats.lists[this.recentFocus.list].findIndex(item => item.id == this.recentFocus.item.id && item.name == this.recentFocus.item.name)
        let minus = 1
        let isTrue = true
        while(isTrue){
          if(this.stats.lists[this.recentFocus.list][index-minus] && this.stats.lists[this.recentFocus.list][index-minus].hidden == true) minus++
          else break
        }
        if(index-minus < 0) return
        let item = this.stats.lists[this.recentFocus.list].splice(index,1)[0]
        this.stats.lists[this.recentFocus.list].splice(index-minus,0, item)
      }
    },

    sortDown(){
      if(this.recentFocus.item){
        let index = this.stats.lists[this.recentFocus.list].findIndex(item => item.id == this.recentFocus.item.id && item.name == this.recentFocus.item.name)    
        let plus = 1
        let isTrue = true
        while(isTrue){
          if(this.stats.lists[this.recentFocus.list][index+plus] && this.stats.lists[this.recentFocus.list][index+plus].hidden == true) plus++
          else break
        }
        if(index+plus >= this.stats.lists[this.recentFocus.list].length) return
        let item = this.stats.lists[this.recentFocus.list].splice(index,1)[0]
        this.stats.lists[this.recentFocus.list].splice(index+plus,0, item)
      }
    },

    currentGear(type){
      let currentGear = this.gear.filter(gear=> gear.count > 0 && gear.type == type)
      return currentGear
    },

    setFocus(list, item) {
      if(item != "null"){
        item.uiType = list
        this.focus[list] = item
        this.recentFocus = {list, item}
      }else{
        this.focus[list] = "null"
      }
      if(item.uiType == "spells" || item.uiType == "maneuver"){
        if(this.shiftDown){
          this.toggleReady(item)
          this.focus[list] = "none"
          this.$nextTick(()=>{
            item.uiType = list
            this.focus[list] = item
            this.recentFocus = {list, item}
          })
        }
        if(this.ctrlDown){
          this.toggleFavorite(item)
          this.focus[list] = "none"
          this.$nextTick(()=>{
            item.uiType = list
            this.focus[list] = item
            this.recentFocus = {list, item}
          })
          
        }
      }
    },

    addCombo(tag){
      if(!this.stats.characterStats.misc.combo){
        this.stats.characterStats.misc.combo = []
      } 
      if(this.stats.characterStats.misc.combo.length == 7){
        this.stats.characterStats.misc.combo.splice(0,1)
      }
      this.stats.characterStats.misc.combo.push(tag)
      if(this.connection){
        this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats.characterStats.misc.combo, type:'combo', type2:'misc'}))
      }
    },
    getComboTags(maneuver){
      let tags = []
      if(maneuver.additionalTags) tags = maneuver.additionalTags
      if(maneuver.type != "Stance" && maneuver.type != "Finisher") tags = tags.concat(this.comboTags[maneuver.school])
      return tags
    },
    recoverAll(type){
      this.stats.lists[type].forEach(item=>{item.expended = false})
      this.stats.lists[type].splice(0,0)
      this.pickerIds[type] = Math.random()
    },

    expendAll(type){
      this.stats.lists[type].forEach(item=>{
        if(item.type != "Stance" && item.type != "Finisher" && !(item.subSchool && item.subSchool[0] == "sterlingTactic")) item.expended = true
      })
      this.pickerIds[type] = Math.random()
    },

    recoverRandom(type){
      if(this.stats.lists[type].length > 0){
        let expended = this.stats.lists[type].filter(item=> (item.expended==true || (item.subSchool && item.subSchool[0] == "sterlingTactic")) && item.type != "Finisher")
        if(expended.length > 0){
          let chosen = expended[Math.floor(Math.random()*expended.length)]
          if(chosen.subSchool && chosen.subSchool[0] == "sterlingTactic") chosen.stacksOne += 1
          else{
            this.toggleReady(chosen)
          }
          this.focusLevel(type, chosen.level)
          this.setFocus(type,chosen)
        }
      }
    },
    expendRandom(type){
      if(this.stats.lists[type].length > 0){
        let ready = this.stats.lists[type].filter(item=> item.expended==false && item.type != "Stance" && item.type != "Finisher")
        if(ready.length > 0){
          let chosen = ready[Math.floor(Math.random()*ready.length)]
          this.toggleReady(chosen)
          this.setFocus(type,chosen)
          this.focusLevel(type, chosen.level)
        }
      }
    },

    sendCharacter(type, type2){
      if(type){
        if(type2){
          this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats, type, type2}))
        }else{
          this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats, type}))
        }
      }else if(this.connection){
        this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats}))
      }
    },

    focusLevel(list, level) {
      //let newSpell = {level: Math.floor(Math.random()*9), name: (Math.random()*10000).toString(), longDesc:"this is decription for this stpell" }
     // this.stats.lists.spells.push(newSpell)
      this.focused[list] = level;
    },

    SorMMeets(item,list) {
      //let newSpell = {level: Math.floor(Math.random()*9), name: (Math.random()*10000).toString(), longDesc:"this is decription for this stpell" }
     // this.stats.lists.spells.push(newSpell)
     if(this.focused[list] == "Finisher") if(item.type == "Finisher") {return true} else {return false}
     if(this.focused[list] == "expended" && item.expended) return true
     else if(this.focused[list] == "favorite" && item.favorite) return true
     else if(item.level == this.focused[list] && item.type != "Finisher") return true 
     else return false
    },
    
    

    requestRoll() {},
    
    emergencySkip(){
      if(this.connection){
        this.connection.send(JSON.stringify({type: "selected", rollId:this.remainingRolls[0].rollId }))
      }
      this.remainingRolls.splice(0, 1);
      if(this.tempPlayerRolls) this.tempPlayerRolls.splice(0,1);
    },

    modifier(stat) {
      let score = this.stats.characterStats.abilityScore[stat];
      let modifier = Math.floor((score - 10) / 2);
      return modifier;
    },
    tempModifier(stat){
      let score = this.stats.characterStats.modifiedStats[stat];
      let modifier = Math.floor((score - 10) / 2);
      return modifier;
    },
    skillModifier(stat){
      let ability = this.skillsList.find(skill => skill.skill == stat).abilityMod
      let abilityMod = 0
      if(ability.length > 1){
        let ability1 = this.tempModifier(ability[0])
        let ability2 = this.tempModifier(ability[1])
        ability = ability1 > ability2 ? ability[0] : ability[1]
      }else{
        ability = ability[0]
      }
      abilityMod = this.tempModifier(ability)
      if(ability == "intelligence"){
        if(stat.includes("know")){
          let tempMod = this.tempModifier(ability) 
          if(tempMod > 0) abilityMod = tempMod * 2
        }
      }      
      if(ability == "strength" || ability == "dexterity"){        
        abilityMod -= Math.abs(parseInt(this.stats.characterStats.tempModifiers.armorCheckPenalty))
      }
      return abilityMod
    },
    essenceCount(){
      let fromRadiantCounter = 0
      let radiantDawnManeuvers = this.stats.lists.maneuver.filter(maneuver=> maneuver.school == "radiantDawn")
      if(radiantDawnManeuvers.length > 0){
        radiantDawnManeuvers.sort(function(a, b){return b.level-a.level})
        if(radiantDawnManeuvers.length > radiantDawnManeuvers[0].level) {fromRadiantCounter = radiantDawnManeuvers[0].level}
        else {fromRadiantCounter = radiantDawnManeuvers.length}
      }
      let fromFeats = this.stats.lists.feats.filter(feat=> feat.givesEssence).length
      return fromFeats + parseInt(fromRadiantCounter)
    },
    getInvestments(){
      let investments = []
      let investedFeats = this.stats.lists.feats.filter(feat=>feat.investedEssence > 0)
      let investedManeuvers = this.stats.lists.maneuver.filter(maneuver=>maneuver.investedEssence > 0)
      if(investedFeats.length > 0){
        investments.push({name:'Feats:', id:Math.random()})
        investments = investments.concat(investedFeats)
      }
      if(investedManeuvers.length > 0){
        investments.push({name:'Maneuvers:', id:Math.random()})
        investments = investments.concat(investedManeuvers)
      }
      return investments
    },
    returnInvestments(item){
      if(item == "all"){
        this.stats.characterStats.investedEssence = 0
        this.getInvestments().forEach(investment => {investment.investedEssence = 0})
        this.showInvestments = false
        this.reset(item)
      }else{
        this.stats.characterStats.investedEssence -= item.investedEssence
        item.investedEssence = 0
        if(this.getInvestments().length == 0) this.showInvestments = false
        this.reset(item)
      }
      
    },
    increaseEssence(item){
      if(this.spellpoints > Math.ceil(this.stats.characterStats.misc.level/2) && this.stats.characterStats.investedEssence+1 <= this.essenceCount()){
        this.stats.characterStats.investedEssence += 1
        item.investedEssence += 1
      }      
      this.reset(item)
      //this.stats.lists[item.uiType].splice(0,0)
    },
    reduceEssence(item){
      if(this.stats.characterStats.investedEssence-1 >= 0 && item.investedEssence-1 >= 0) {
        this.stats.characterStats.investedEssence-=1
        item.investedEssence -= 1
      }
      //this.stats.lists[item.uiType].splice(0,0)
      this.reset(item)
    },
    buttonMethod(item,buttonMethod){
      let perk = this.allPerks.find(perk => perk.name == item.name)
      perk[buttonMethod.method](this, perk, item)
    },
    focusPotion(potion){
      this.focusedPotion = potion
      this.newFocusedPotion = true
    },

    usePotion(potion){            
      potion.count -= 1
      for(let x = 0; x < this.potions[potion.type].length; x++){
        if(this.potions[potion.type][x] == potion.id){
          this.potions[potion.type].splice(x, 1, potion)
        }
      }
      this.connection.send(JSON.stringify({command:"usedPotion", potion:potion}))
    },

    useGear(gear){            
      let index = this.gear.findIndex(allGear=> allGear.name == gear.name)      
      let temp = this.gear[index]
      temp.count--
      this.gear.splice(index,1,temp)
      this.connection.send(JSON.stringify({command:"usedGear", gear:temp}))
    },
    
    sendGold(){
      if(this.goldAmount > 0){
        if(this.goldAmount <= this.stats.gold){
          this.connection.send(JSON.stringify({command:"sendGold", gold:this.goldAmount}))
          this.stats.gold -= this.goldAmount
          this.goldAmount = 0
          this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats}))
        }else{
          this.goldAmount = "You Broke xd"
        }
      }else if(this.goldAmount < 0){
        this.goldAmount *= -1
        this.sendGold()        
      }
    },
    sendGoldTo(){
      if(this.goldAmount > 0){
        if(this.goldAmount <= this.stats.gold){
          this.connection.send(JSON.stringify({command:"sendGoldTo", gold:this.goldAmount, target:this.sendGoldTarget}))
          this.stats.gold -= this.goldAmount
          this.goldAmount = 0
          this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats}))
        }else{
          this.goldAmount = "You Broke xd"
        }
      }else if(this.goldAmount < 0){
        this.goldAmount *= -1
        this.sendGold()        
      }
    },

    buyItem(item){
      this.stats.gold -= item.price
      if(item.specific && item.specificType != "gear"){
        if(item.specificType != "stats"){
          this.stats.lists[item.specificType].push(item.option)
          if(item.option.hasCustomMethod){
            let foundItem
            if(item.option.uiType == "perks"){
              foundItem = this.allPerks.filter(perk=>perk.name==item.option.name)[0]
            }else if(item.option.uiType == "feats"){
              foundItem = feats.filter(feat=>feat.name==item.option.name)[0]
            }

            if(foundItem.catchUpMethod){
              foundItem.catchUpMethod(this, foundItem, item.option)
            }
        }
        }else{
          this.addStats(item.option)
        }        
      }else{
        if(item.name == "Maneuver Trade Up"){
          this.createTradeUp()
        }else if(item.name == "Gambling"){
          let goldReturn = Math.floor(Math.random()*100)
          if(goldReturn < 15) goldReturn = 0
          if(goldReturn > 90) goldReturn *= 2
          this.stats.gold += goldReturn
        }else if(item.name == "Reroll Hit Points"){
          for(let x = 1; x < this.stats.characterStats.hpIncreases.length; x++){                
             this.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * this.stats.characterStats.misc.HDSize))
          }   
        } else {
           if(item.name.includes("Spell") || item.name.includes("Maneuver")){
            this.getSpellOrManeuver(item)
          }
          if(item.typed){
            this.createTypedCustomDialog(item)
          }
        }
      }
      
      if(item.name == "Item Trade"){
        this.makeItemTradeCustom()
      }

      this.sendCharacter()
      this.connection.send(JSON.stringify({command:"buyItem", item:item.id}))      
    },

    createTradeUp(carryOvers){
      if((!carryOvers || carryOvers.length == 0) && this.stats.lists.maneuver.length < 3){
        this.customDialogArray.push({title:"Wait, No Trade Up?",id:Math.random(),options:[{title:"I Dont Have Enough Maneuvers...?",description:"It's okay, reading is hard. rip gold tho, Amelia doesn't do refunds for stupidity.",id:0,method:(context)=>{context.doNothing = 'donothing'}
        },{title:"Wait Amelia-sama 👉👈... Pwease Wefund?",description:"I just made a wittle fwucky wucky",id:1,
         method:(context)=>{
          let vineBoomSound = new Audio(vineBoom)
          vineBoomSound.volume = 0.33
          vineBoomSound.play()
          context.customDialogArray.push({title:"Chat is this guy fr?",id:Math.random(),options:[{title:"Sorry, i will read better Amelia-Sama 😩",id:0,method:(context)=>{context.doNothing='doNothing'}}]})}
        }]})
        return
      } 
      if(carryOvers && carryOvers.length == 3){
        if(carryOvers[0].school && carryOvers[0].school == carryOvers[1].school && carryOvers[1].school == carryOvers[2].school){
          let options = {type:{Finisher:true},school:{}}
          options.school[carryOvers[0].school] = true
          this.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options}))
        }else{
          this.getSpellOrManeuver({name:"Maneuver School"})
        }
      }else{
        if(!carryOvers) carryOvers = []
        let custom = {title:"Maneuver Trade Up", options:[]}
        this.stats.lists.maneuver.forEach(maneuver=>{
          let option  = {
              title:maneuver.name,
              id:Math.random(),
              item:maneuver,
              carryOvers,
              method:(context =>{
                let index = context.stats.lists.maneuver.indexOf(maneuver)
                let carryOver = context.stats.lists.maneuver.splice(index,1)[0]
                carryOvers.push(carryOver)
                context.createTradeUp(carryOvers)
              })
            }
            custom.options.push(option)
        })
        custom.options = custom.options.sort(function(a,b){return a.title.localeCompare(b.title)})
        this.customDialogArray.push(custom)
      }
    },

    makeItemTradeCustom(){
      let lists = ["weapon","armor","wonderousItems"]
      let blacklist = ["Unarmed", "Rock", "Unarmored"]
      let choices = []
      for(let y = 0; y < 3; y++){
        for(let x = 0; x < this.stats.lists[lists[y]].length; x++){
          let item = this.stats.lists[lists[y]][x]
          if(!blacklist.includes(item.name) && item.type != "custom"){
            let choice  = {
              title:item.name,
              id:Math.random(),
              method:(context =>{
                context.chooseTradeTarget(context, item)
                let index = context.stats.lists[lists[y]].findIndex(invItem => invItem.id == item.id)
                let sellableIndex = this.store.sellableItems.findIndex(sellable => sellable.item && sellable.item.id == item.id)
                if(sellableIndex != -1) this.store.sellableItems.splice(sellableIndex, 1, {})
                context.stats.lists[lists[y]].splice(index, 1)
              })
            }
            choices.push(choice)
          }
        }
      }
      if(choices.length > 0){
        let custom = {title:"Choose Item", options:choices}         
        this.customDialogArray.push(custom)
      }
    },

    chooseTradeTarget(context, item){
      let choices = []
      let x = 0
      context.store.playerNames.forEach(player =>{
        if(player != context.name){
          let choice = {
            title:player,
            id:x,
            method:(() =>{
              item.target = player
              context.connection.send(JSON.stringify({command:"tradeItem", item}))
            })
          }
          x++
          choices.push(choice)
        }
      })
      let custom = {title:"Choose Player", options:choices}
      context.customDialogArray.push(custom)      
    },

    notMe(){
      if(this.store.playerNames){
        return this.store.playerNames.filter(name => name != this.name)
      }else{
        return []
      }
    },

    createNewWeapon(){
      if(this.newWeapon.name.length >= 2 && this.newWeapon.damage.length >= 2){
        let weapon = {name: this.newWeapon.name, id:Math.random(), rarity:"none", class:"melee", type: "custom", damage: this.newWeapon.damage, damageType: this.newWeapon.damageType, crit: this.newWeapon.critical, special: this.newWeapon.notes, uiType:"weapon", enchantments:[], hitPoints:1, hardness:1, range:"-", statsForAbilities:{atkStat:"strength",  bonusAtk:0,  dmgStat:"strength",  bonusDmg:0,  dieSteps:0,},}
        this.stats.lists.weapon.push(weapon)
        this.newWeaponDialog = false
        this.newWeapon = {name:"",damage:"",damageType:"",critical:"",notes:``}
      }else{
        this.newWeaponDialog = true
      }
    },

    sendNotes(){
      let groupNotes = this.groupNotes
      this.connection.send(JSON.stringify({command:"groupNotes", notes:groupNotes}))
    },

    getSpellOrManeuver(item, itemOptions){
      let type = item.name.includes("Spell") ? "spell" : "maneuver"
      let spellOptionsArr
      let maneuverschoolsArr
      let maneuverTypesArr
      if(type == "spell"){
        if(itemOptions && itemOptions.type) spellOptionsArr = itemOptions.type
        else spellOptionsArr = ["damage", "healing", "buff", "control", "utility"]
      } 
      if(type == "maneuver"){
        if(itemOptions && itemOptions.type) maneuverTypesArr = itemOptions.types
        else maneuverTypesArr = ["Boost", "Strike","Counter", "Stance"]
        if(itemOptions && itemOptions.school) maneuverschoolsArr = itemOptions.school
        else maneuverschoolsArr = ["blackSeraph","brokenBlade","brutalCrocodile","burningCitadel","crimsonReaper","cursedRazor","elementalFlux","eternalGuardian","goldenLion","heartOfTheMaelstrom","indomitableWill","ironTortoise","mithralCurrent","piercingThunder","primalFury","radiantDawn","rivenHourglass","scarletThrone","shadowAssassin","shatteredMirror","silverCrane","sleepingGoddess","solarWind","steelSerpent","sterlingSovereignty","tempestGale","thrashingDragon","unquietGrave","veiledMoon"]
      }

      let optionsArr
      if(type == "spell"){
        if(item.name.includes("Typed")){
          optionsArr = spellOptionsArr
        }
      }else{
        if(item.name.includes("Typed")){
          optionsArr = maneuverTypesArr
        }else if(item.name.includes("School")){
          optionsArr = maneuverschoolsArr
        }
      }
      let options = []
      if(optionsArr){
        for(let x = 0; x < optionsArr.length; x++){
          let newOption = {}
          newOption.title = optionsArr[x]
          newOption.id = x
          newOption.description
          newOption.method = (context)=>{
            let levels = this.getSpellAtCurrentLevel(type)
            let spellOptions = {level:levels}
            if(item.name.includes("School")){
              spellOptions.school = {}
              spellOptions.school[optionsArr[x]] = true
            }else{
              spellOptions.type = {}
              spellOptions.type[optionsArr[x]] = true
            }
            let newRequest = {command:"requestRoll", type, options:spellOptions}
            context.connection.send(JSON.stringify(newRequest))
          }
          options.push(newOption)
        }
        let customDialog = {title:"Typed "+ type + " Selection", options}
        this.customDialogArray.push(customDialog)
      }else{
        let spellOptions = {level:this.getSpellAtCurrentLevel(type)}
        let newRequest = {command:"requestRoll", type, options:spellOptions}
        this.connection.send(JSON.stringify(newRequest))
      }      
    },

    getSpellAtCurrentLevel(type){
      let lvlNum = Math.ceil(this.stats.characterStats.misc.level/2)+1
      if(lvlNum > 9){lvlNum = 9}
      let levels = {}
      let min = type=="spell" ? 0 : 1
      for(let x = 0; x < 4; x++){
          if(lvlNum-x >= min){
              let level = lvlNum-x
              let levelString="lvl"+level;
              levels[levelString]=true;
          }
      }     
      return levels
    },

    

    createTypedCustomDialog(item){
      let optionsArr = Object.keys(item.types)
      let options = []
      for(let x = 0; x < optionsArr.length; x++){
          let newOption = {}
          newOption.title = optionsArr[x]
          newOption.id = x
          newOption.method = (context)=>{
            let itemOptions = {}
            if(item.specificType == "armor"){
               item.types[optionsArr[x]] = true
               itemOptions.armor = {type:item.types}
               if(item.name.includes("enchanted")){
                itemOptions.armor.enchanted = true
              }
            }else if(item.specificType == "weapon"){
              item.types[optionsArr[x]] = true
              itemOptions.weapon = {type:item.types}
              if(item.name.includes("enchanted")){
                itemOptions.weapon.class = {enchanted: true, melee: true, ranged: true}
              }
            }else if(item.specificType == "perks"){
              item.types[optionsArr[x]] = true
              itemOptions.type = item.types
            }else if(item.specificType == "feats"){
              item.types[optionsArr[x]] = true
              itemOptions = item.types
            }else if(item.specificType == "wonderousItems"){
              item.types[optionsArr[x]] = true
              itemOptions.type = item.types
            }else if(item.specificType == "maneuver"){
              item.types[optionsArr[x]] = true
              itemOptions.school = {}
              itemOptions.type = {Finisher:true}
              itemOptions.school[optionsArr[x]] = true
              itemOptions.onlyFinisher = true
            }
                        
            let newRequest = {command:"requestRoll", type:item.specificType, options:itemOptions}
            context.connection.send(JSON.stringify(newRequest))
          }
          options.push(newOption)
        }
        let customDialog = {title:"Typed "+ item.specificType + " Selection", options}
        this.customDialogArray.push(customDialog)
    },

    sellItem(item){
      let index = -1
      for(let x = 0; x < this.stats.lists[item.item.uiType].length; x++){
        if(this.stats.lists[item.item.uiType][x].id == item.item.id){
          index = x
        }
      } 
      if(index == -1){
        console.log("couldnt find for some reason??", item.item, this.stats.lists[item.item.uiType])
      }else{
        this.stats.lists[item.item.uiType].splice(index, 1)
        this.store.sellableItems.splice(item.id, 1, {})
        this.stats.gold += parseInt(item.price)
        this.connection.send(JSON.stringify({command:"characterSheet", data:this.stats}))
      }
    },

    getItemSellPrice(item){
      if(item.uiType == "requestWeapon") item.uiType = "weapon"
      else if(item.uiType == "armorForEnchantment") item.uiType = "armor"
      let price = 5
      if(item.uiType == 'weapon' || item.uiType == "armor"){
        if(item.rarity == "common") price += 5
        else if(item.rarity == "rare") price += 10
        else if(item.rarity == "epic") price += 20
        else if(item.rarity == "legendary") price += 40
        else if(item.rarity == "unique") price += 80
        else if(item.rarity == "none") price += 10
      }else if(item.uiType == 'wonderousItems'){
        if(item.rarity == "common") price += 10
        else if(item.rarity == "rare") price += 20
        else if(item.rarity == "epic") price += 40
        else if(item.rarity == "legendary") price += 80
        else if(item.rarity == "unique") price += 160
      } else{
        price += 15
      }
      if(item.enchantments){
        item.enchantments.forEach(enchantment=>{
          if(enchantment.rarity == "common") price += 30
          else if(enchantment.rarity == "rare") price += 40
          else if(enchantment.rarity == "epic") price += 60
          else if(enchantment.rarity == "legendary") price += 80
          else if(enchantment.rarity == "unique") price += 120
        })
      }
      return price
    },

    runCustomMethod(method, self){      
      let foundPerk = this.allPerks.filter(perk=>perk.name==self.name)[0]
      method(this, foundPerk, self)
      this.customDialogArray.splice(0,1)
      this.$nextTick(() => {
        this.sendCharacter()
        this.connection.send(JSON.stringify({command:"CustomDialogs", data:this.customDialogArray}))
      })
    },

    printFeats(){
      console.log(feats)
    },

    capitalize(str){
      for(let x = 0; x < str.length; x++){
        if(str[x].toUpperCase() == str[x]){
          str = str.substring(0,x) + " " + str.substring(x,str.length)
          break;
        }
      }            
      let newStr = str[0].toUpperCase() + str.substring(1)
      return newStr
    },

    showHiddenDialog(list){
      this.hiddenDialog.type = list
      this.hiddenDialog.show = true
      this.hiddenDialog.items = this.stats.lists[list]
    },

    hideItem(item){
      if(item.hidden){
        item.hidden = !item.hidden        
      }else{
        this.setFocus(item.uiType,"null")
        item.hidden = true
      }
      this.stats.lists[item.uiType].splice(0,0)
    },
    toggleReady(item){
      item.expended = !item.expended
      this.reset(item)
      //this.stats.lists[item.uiType].splice(0,0)
    },
    toggleFavorite(item){
      item.favorite = !item.favorite
      //let index = this.stats.lists[item.uiType].findIndex(listItem=>listItem.id == item.id && listItem.name == item.name)
      //this.stats.lists[item.uiType].splice(0,0)
      this.reset(item)
    },
    hasItemsOf(list,parameter){
      if(parameter == "Finisher"){
        if(list.find(item=> item.type == "Finisher")) return true
      }else{
        if(list.find(item=> item[parameter])) return true
      }
      return false
    },

    reset(item){
      this.pickerIds[item.uiType] = Math.random()
    },


    listHasHidden(list){      
      let found = false
      this.stats.lists[list].forEach(item=>{
        if(item.hidden){
          found = true
        }
      })
      return found
    },

    async getClassDetails(className){
      await fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "getClassDetails",
          email:this.username,
          password:this.password,
          className
        }),
      }).then(async (response) => {
        let responseText = await response.text()
        console.log("get account response:", responseText)
        this.accountPerks = JSON.parse(responseText)
        return "good"
      }) 
    },

    destroy(item){
      let index = this.stats.lists[item.uiType].findIndex(existingItem=> existingItem.id == item.id)
      if(index != -1){
        this.stats.lists[item.uiType].splice(index, 1)
        this.setFocus(item.uiType, "null")
      }
    },

    rollForItem(rollMod, item){
      let roll = Math.ceil(Math.random()*100)
      if(rollMod == "greed") roll -= 15
      if(rollMod == "skip") roll = 0
      if(rollMod == "greed" && this.stats.characterStats.misc.race == "Goblin") roll += 25
      let index = this.wonderousItems.findIndex(foundItem => item.id == foundItem.item.id)      
      this.connection.send(JSON.stringify({command:"itemRoll", roll, item:item,timeLeft:this.wonderousItems[index].intervalCount}))
      if(index != -1){
        this.wonderousItems[index].roll = roll
        //this.wonderousItems.splice(index, 1)
      }
    },
    
    backColor(item){
      let color = ""
      let rarity = item.rarity
      if(item.uiType == "spells"){
        if(item.type[0] == "damage") color = "red"
        else if(item.type[0] == "healing") color = "green"
        else if(item.type[0] == "buff") color = "gold"
        else if(item.type[0] == "control") color = "dark"
        else if(item.type[0] == "utility") color = "white"
      }else if(item.uiType == "maneuver"){
        if(item.type == "Strike") color = "red"
        else if(item.type == "Boost") color = "gold"
        else if(item.type == "Finisher") color = "light_blue"
        else if(item.type == "Counter") color = "purple"
        else if(item.type == "Stance") color = "white"
      }else if(rarity =="common") color = "grey"
      else if(rarity =="rare") color = "blue"
      else if(rarity =="epic") color = "purple"
      else if(rarity =="legendary") color = "gold"
      else if(rarity =="unique") color = "red"
      else if(rarity =="forbidden") color = "black"
      else if(rarity =="class") color = "light_blue"
      else color = "white"
      if(color == "") console.log("bad item", item)
      return "Background_" + color +".png"
    },

    textColor(item){
      let color = "#000000"
      if(item.rarity){
        //if(rarity =="legendary" || rarity =="unique" ) return "#FFFFFF"
        if( item.rarity =="none") return "#000000"
        else if(item.rarity !="none") return "#FFFFFF"
      }
      if(item.type[0] == "utility") color = "#000000"
      else color = "#FFFFFF"
      if(item.expended == true) color = "#ff0000"
      return color
    },
    spellColor(spellType){
      let colorArr = {fire: "red", acid:"green", cold:"rgba(68, 179, 225, 255)", electricity:"yellow", positive:"white", negative:"rgb(36, 7, 51)", universal:"rgba(216, 109, 205, 255)"}
      if(colorArr[spellType]) return colorArr[spellType]
      else return "#000000"
    },
    spellTitleColor(spellType){
      if(spellType =="negative") return "rgba(255,255,255,1)"
      else return this.spellColor(spellType)
    },
    comboColor(tag){
      let colorArr = {Air: "rgba(192, 230, 245, 255)", Arcane: "rgba(12, 118, 158, 255)", Curse: "rgba(81, 21, 74, 255)", Power: "rgba(0,100,0,255)", Dark: "rgba(0, 0, 0, 255)",Death: "rgba(14, 0, 33, 1)", Earth:"rgba(153, 125, 55, 255)", Fire: "rgba(255, 110, 1, 255)", Flurry: "rgba(192, 0, 0, 255)", Guardian:"rgba(190, 80, 20, 255)", Heroic:"rgba(255, 255, 0, 255)", Light: "rgba(255, 255, 153, 255)",Primal:"rgba(192, 0, 0, 255)", Royal:"rgba(120, 33, 112, 255)", Sakura:"rgba(242, 206, 239, 255)", Shadow:"rgba(128, 128, 128, 255)", Technique:"rgba(71, 211, 89, 255)", Void:"rgba(216, 109, 205, 255)", Water:"rgba(68, 179, 225, 255)",elementalFlux:"rgba(163, 89, 83, 255)",solarWind:"rgba(245, 179, 66, 255)"}      
      if(colorArr[tag]) return colorArr[tag]
      else return "#000000"
    },
    comboShadowColor(tag){
      if(tag =="Death") return "rgba(255,255,255,1)"
      else if(tag =="Dark") return "rgba(14, 0, 33, 1)"
      else return this.comboColor(tag)
    },
    additionalComboColor(tag){
      if(tag =="Dark") return ",rgba(0, 0, 0, 10) 0px 0px 25px,rgba(0, 0, 0, 10) 0px 0px 100px"
      else if(tag =="Death") return ",rgb(14, 0, 33) 0px 0px 25px,rgb(14, 0, 33) 0px 0px 25px,rgb(14, 0, 33) 0px 0px 25px"
      else return ""
    },
    comboTextColor(tag){      
      let whiteArr =["Dark","Death","Royal","Curse","Technique","Flurry"]
      if(whiteArr.includes(tag)) return "#FFFFFF"
      else return "#000000"
    },
    setHover(list){
      this.hoveringItem = list
    }
  },  

  capitalize(str){  
    for(let x = 0; x < str.length; x++){
      if(str[x].toUpperCase() == str[x]){
        str = str.substring(0,x) + " " + str.substring(x,str.length)
        break;
      }
    }
    let newStr = str[0].toUpperCase() + str.substring(1)
    return newStr
  },
  
}
</script>
<style>
.btn-multiline > span {
  width: 100%;
  color:white;
}
.aligned-col{
  display:flex;
  align-items: baseline;
}
.div.btn__content {
  padding: 0;
}

.div.card__actions .btn {
  min-width: 0;
}
.storeBackground .v-image__image{
  background-repeat:repeat-y; 
  background-size:auto;
  background-size:contain;
}

.background .v-image__image{
  background-repeat: round;
  background-size: contain !important; 
}
.background .not-background .v-image__image{
  background-repeat: no-repeat;
  background-size: cover !important; 
  background-position: left top!important;
}
.light::-webkit-scrollbar {
  width: 8px;
}

.light::-webkit-scrollbar-track {
  background: rgb(0,0,0,0);
}

.light::-webkit-scrollbar-thumb {
  background: rgb(89, 58, 52);  
  border-radius: 7px;
}

.light .v-input__slot::-webkit-scrollbar{
  width: 8px;
}

.darkBar2::-webkit-scrollbar {
  width: 8px;
}

.darkBar2::-webkit-scrollbar-track {
  background: rgb(0, 0, 0);
}

.darkBar2::-webkit-scrollbar-thumb {
  background: rgb(107, 36, 0);  
  border-radius: 7px;
}

.darkBar2 .v-input__slot::-webkit-scrollbar{
  width: 8px;
}


.darkBar::-webkit-scrollbar {
  width: 8px;
}

.darkBar::-webkit-scrollbar-track {
  background: rgb(0, 0, 0);
}

.darkBar::-webkit-scrollbar-thumb {
  background: rgb(54, 52, 51);  
  border-radius: 7px;
}

.darkBar .v-input__slot::-webkit-scrollbar{
  width: 8px;
}

.light2::-webkit-scrollbar {
  width: 8px;
}

.light2::-webkit-scrollbar-track {
  background: rgb(0,0,0,0);
}

.light2::-webkit-scrollbar-thumb {
  background: rgb(223,194,162);  
  border-radius: 7px;
}

.light2 .v-input__slot::-webkit-scrollbar{
  width: 8px;
}

.pickerCardWhite:hover{
  box-shadow: rgb(255, 255, 255) 0 0 100px;
  text-shadow: rgb(255, 255, 255) 0 0 10px;
  cursor: pointer;
}

.pickerCardGray:hover{
  box-shadow: rgb(92, 92, 92) 0 0 100px;
  text-shadow: rgb(255, 255, 255) 0 0 10px;
  cursor: pointer;
}

.pickerCardBlue:hover{
  box-shadow: rgb(58, 51, 153) 0 0 100px;
  text-shadow: rgb(255, 255, 255) 0 0 10px;
  cursor: pointer;
}

.pickerCardPurple:hover{
  box-shadow: rebeccapurple 0 0 100px;
  text-shadow: rgb(255, 255, 255) 0 0 10px;
  cursor: pointer;
}

.pickerCardOrange:hover{
  box-shadow: rgb(255, 123, 0) 0 0 100px;
  text-shadow: rgb(255, 255, 255) 0 0 10px;
  cursor: pointer;
}
.pickerCardRed:hover{
  box-shadow: rgb(143, 0, 0) 0 0 100px;
  text-shadow: rgb(255, 255, 255) 0 0 10px;
  cursor: pointer;
}
.pickerCardBlack:hover{
  box-shadow: rgb(0, 0, 0) 0 0 100px;
  text-shadow: rgb(255, 255, 255) 0 0 10px;
  cursor: pointer;
}

.firefoxScroll{
  scrollbar-color: sienna transparent ;
  scrollbar-width: thin;
}
.v-slide-group__prev{
  width:22px!important;
  min-width:22px!important;
  flex: 0 1 22px!important;
  border-right: 4px;
  border-style: ridge;
  border-color: saddlebrown;
  border-top: 0px;
  border-left: 0px;
  border-bottom: 0px;
  border-radius: 30px;
}
.v-slide-group__next{
  width:22px!important;
  min-width:22px!important;
  flex: 0 1 22px!important;
  border-left: 4px;
  border-style: ridge;
  border-color: saddlebrown;
  border-top: 0px;
  border-right: 0px;
  border-bottom: 0px;
  border-radius: 20px;
}
.borderimg{
  border: 4px solid transparent;
  border-image: url('../assets/Background_red.png') 60 round;
}
.hiddenMenu, .v-menu__content {
  overflow-y: hidden!important;
  margin-left:12px;
}
.nooverflow{
  overflow: hidden !important;
  max-height: 100%;
  min-height: 70vh;
}
.draggable-notes {
  will-change: transform;
  cursor: move;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}
.no-background.v-icon.v-icon::after {
  background-color: transparent;
}
table, th, td {
  border:1px solid black;
}
td{
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
}
th{
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}
</style>